(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["login-form"] && !Shopify.designMode) return;
  try {
    (() => {
  function init() {
    const panel=document.getElementById('login-dropdown');
    if(!panel || panel.dataset.pnmSigninEnhanced)return;
    panel.dataset.pnmSigninEnhanced='true';
    const desktop=window.matchMedia('(min-width:1025px)');
    const triggers=[...document.querySelectorAll('[data-login-dropdown-pc],[data-login-toggle]')];
    let pending=false;
    const isOpen=()=>desktop.matches ? triggers.some(node=>node.matches('[data-login-dropdown-pc].is-open')) : document.body.classList.contains('open_Account');
    function sync() {
      pending=false;
      const open=isOpen();
      triggers.forEach(node=>{
        node.setAttribute('aria-controls','login-dropdown');
        node.setAttribute('aria-expanded',String(open));
        node.setAttribute('aria-label',panel.querySelector('.login-title').textContent.trim());
      });
      if(desktop.matches && open) {
        const top=panel.getBoundingClientRect().top;
        panel.style.maxHeight=Math.max(120,window.innerHeight-top-16)+'px';
      } else panel.style.removeProperty('max-height');
    }
    function schedule(){if(!pending){pending=true;requestAnimationFrame(sync);}}
    document.addEventListener('click',event=>{
      if(isOpen() || event.target.closest?.('[data-login-dropdown-pc],[data-login-toggle],[data-close-login-dropdown-pc],[data-close-login-dropdown]'))schedule();
    },true);
    document.addEventListener('keydown',event=>{
      if(event.key!=='Escape' || !isOpen())return;
      event.preventDefault();
      const selector=desktop.matches?'[data-close-login-dropdown-pc]':'[data-close-login-dropdown]';
      panel.querySelector(selector)?.click();
      const trigger=triggers.find(node=>node.matches(desktop.matches?'[data-login-dropdown-pc]':'[data-login-toggle]') && node.getClientRects().length);
      trigger?.focus();
      schedule();
    });
    window.addEventListener('resize',schedule,{passive:true});
    sync();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init,{once:true});
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-card-feedback"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.PNMCardFeedback) return;
  const configNode = document.querySelector('[data-pnm-cart-feedback-config]');
  if (!configNode) return;
  let labels;
  try { labels = JSON.parse(configNode.textContent); } catch (error) { return; }
  const tickets = new WeakMap();

  function restore(ticket) {
    const { button } = ticket;
    button.replaceChildren(...ticket.nodes.map(node => node.cloneNode(true)));
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.removeAttribute('data-pnm-cart-state');
  }

  function start(button) {
    const card = button.closest('.product-card.pnm-card[data-product-card]');
    if (!card) return null;
    const previous = tickets.get(button);
    if (button.disabled || previous?.state === 'adding') return false;
    if (previous) {
      clearTimeout(previous.timer);
      restore(previous);
    }
    const form = button.closest('form');
    const variantId = form?.querySelector('[name="id"]')?.value;
    let message = card.querySelector('[data-pnm-cart-message]');
    if (!message) {
      message = document.createElement('p');
      message.className = 'pnm-cart-feedback-message';
      message.setAttribute('data-pnm-cart-message', '');
      message.setAttribute('role', 'status');
      message.setAttribute('aria-live', 'polite');
      message.setAttribute('aria-atomic', 'true');
      card.querySelector('.product-actions').appendChild(message);
    }
    message.textContent = '';
    message.removeAttribute('data-state');
    const ticket = { button, card, message, variantId: String(variantId || ''),
      nodes: Array.from(button.childNodes).map(node => node.cloneNode(true)), state: 'adding' };
    tickets.set(button, ticket);
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('data-pnm-cart-state', 'adding');
    card.setAttribute('data-pnm-cart-feedback', 'adding');
    button.textContent = labels.adding;
    return ticket;
  }

  function error(ticket, response) {
    if (!ticket || ticket.state !== 'adding') return;
    ticket.state = 'error';
    restore(ticket);
    ticket.card.setAttribute('data-pnm-cart-feedback', 'error');
    ticket.message.setAttribute('data-state', 'error');
    const description = response?.description;
    ticket.message.textContent = typeof description === 'string' && description.trim()
      ? description.trim() : labels.error;
  }

  function success(ticket, response) {
    if (!ticket || ticket.state !== 'adding') return;
    const items = Array.isArray(response?.items) ? response.items : [response];
    const confirmed = ticket.variantId && items.some(item => item &&
      String(item.variant_id || item.id) === ticket.variantId && Number(item.quantity) > 0);
    if (!confirmed || Number(response?.status) >= 400) {
      error(ticket);
      return;
    }
    ticket.state = 'added';
    ticket.button.disabled = false;
    ticket.button.removeAttribute('aria-busy');
    ticket.button.setAttribute('data-pnm-cart-state', 'added');
    ticket.card.setAttribute('data-pnm-cart-feedback', 'added');
    ticket.button.textContent = '✓ ' + labels.added;
    const title = ticket.card.querySelector('.product-title')?.textContent.trim() || '';
    ticket.message.textContent = labels.added_message.replace('__product__', title);
    ticket.timer = setTimeout(() => {
      if (tickets.get(ticket.button) !== ticket || ticket.state !== 'added') return;
      restore(ticket);
      ticket.card.removeAttribute('data-pnm-cart-feedback');
      ticket.message.textContent = '';
      tickets.delete(ticket.button);
    }, 4000);
  }

  window.PNMCardFeedback = { start, success, error };
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-card-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.pnmCardNavigationReady || !document.body.classList.contains('template-collection')) return;
  window.pnmCardNavigationReady = true;
  const selector = ':is(#gf-grid, #collection-page) .product-card.layout-1[data-product-card]';
  const pending = new Set();
  let queued = false;

  function enhance(card) {
    const link = card.querySelector('.product-title a[href]');
    if (!link || !link.textContent.trim()) return;
    const href = link.getAttribute('href');
    try {
      const url = new URL(href, location.origin);
      if (url.origin !== location.origin || !url.pathname.includes('/products/')) return;
    } catch (error) {
      return;
    }
    if (!link.querySelector('[data-pnm-card-link-text]')) {
      const text = document.createElement('span');
      text.setAttribute('data-pnm-card-link-text', '');
      while (link.firstChild) text.appendChild(link.firstChild);
      link.appendChild(text);
    }
    if (!link.hasAttribute('data-pnm-card-primary-link')) link.setAttribute('data-pnm-card-primary-link', '');
    if (link.getAttribute('draggable') !== 'false') link.setAttribute('draggable', 'false');
    if (!card.hasAttribute('data-pnm-card-navigation')) card.setAttribute('data-pnm-card-navigation', '');
  }

  function flush() {
    queued = false;
    pending.forEach(card => {
      if (card.isConnected) enhance(card);
    });
    pending.clear();
  }

  function collect(node) {
    if (node.nodeType !== 1) return;
    const card = node.closest(selector);
    if (card) pending.add(card);
    node.querySelectorAll(selector).forEach(item => pending.add(item));
  }

  function schedule() {
    if (!queued && pending.size) {
      queued = true;
      requestAnimationFrame(flush);
    }
  }

  function protectTextSelection(root) {
    let gesture = null;
    root.addEventListener('pointerdown', event => {
      const link = event.target.closest('[data-pnm-card-primary-link]');
      gesture = link ? { link, id: event.pointerId, x: event.clientX, y: event.clientY, moved: false } : null;
    }, { capture: true, passive: true });
    root.addEventListener('pointermove', event => {
      if (gesture && gesture.id === event.pointerId &&
          Math.hypot(event.clientX - gesture.x, event.clientY - gesture.y) > 5) gesture.moved = true;
    }, { capture: true, passive: true });
    root.addEventListener('pointercancel', event => {
      if (gesture?.id === event.pointerId) gesture.moved = true;
    }, { capture: true, passive: true });
    root.addEventListener('click', event => {
      const link = event.target.closest('[data-pnm-card-primary-link]');
      if (!link || event.detail === 0) return;
      const selection = window.getSelection();
      const selecting = selection && !selection.isCollapsed &&
        (link.contains(selection.anchorNode) || link.contains(selection.focusNode));
      if ((gesture?.link === link && gesture.moved) || selecting) {
        event.preventDefault();
        event.stopPropagation();
      }
      gesture = null;
    }, true);
  }

  function start() {
    document.querySelectorAll(selector).forEach(enhance);
    const root = document.getElementById('MainContent') || document.body;
    protectTextSelection(root);
    new MutationObserver(records => {
      records.forEach(record => {
        const card = record.target.nodeType === 1 ? record.target.closest(selector) : null;
        if (card) pending.add(card);
        record.addedNodes.forEach(collect);
      });
      schedule();
    }).observe(root, { childList: true, subtree: true });
    window.addEventListener('globoFilterRenderCompleted', () => {
      document.querySelectorAll(selector).forEach(card => pending.add(card));
      schedule();
    });
    document.addEventListener('shopify:section:load', event => {
      collect(event.target);
      schedule();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-card-status"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.pnmCardStatusReady) return;
  window.pnmCardStatusReady = true;
  const cardSelector = '[data-pnm-card-status]';
  const configNode = document.querySelector('[data-pnm-fitment-config]');
  if (!configNode) return;
  let labels;
  try { labels = JSON.parse(configNode.textContent); } catch (error) { return; }
  let scheduled = false;

  function manufacturer(value) {
    const values = String(value || '').split(',').map(item => item.trim().replace(/ - ATV$/, ''));
    return values[0] && values.every(item => item === values[0]) ? values[0] : '';
  }

  function selectedBike() {
    const link = document.querySelector('[data-pnm-bike-parts]:not([hidden])');
    if (!link || !link.getAttribute('href')) return null;
    try {
      const url = new URL(link.getAttribute('href'), location.origin);
      if (url.origin !== location.origin) return null;
      const one = key => url.searchParams.getAll(key).length === 1 ? url.searchParams.get(key) : '';
      return { brand: manufacturer(one('gff_705339')), model: one('gff_705341'), year: one('gff_705342') };
    } catch (error) { return null; }
  }

  function fitmentState(tags, bike) {
    if (tags.includes('Universal/Custom') || tags.includes('Universal')) return 'universal';
    if (!bike) return '';
    if (!bike.model || !bike.brand) return 'choose_model_year';
    if (!/^\d{4}$/.test(bike.year || '')) return 'choose_year';
    const exactTag = bike.model + ' (' + bike.year + ')';
    return tags.some(tag => manufacturer(tag) === bike.brand) && tags.includes(exactTag) ? 'fits' : 'not_listed';
  }

  function updateCard(card, bike) {
    if (card.hasAttribute('data-pnm-cj360-fitment-review')) return;
    const badge = card.querySelector('[data-pnm-card-fitment]');
    if (!badge) return;
    const tags = (card.getAttribute('data-pnm-fit-tags') || '').split('||');
    const state = fitmentState(tags, bike);
    const key = [state, bike?.brand || '', bike?.model || '', bike?.year || ''].join('|');
    if (badge.dataset.pnmFitKey === key) return;
    badge.dataset.pnmFitKey = key;
    badge.dataset.fitState = state;
    badge.hidden = !state;
    badge.replaceChildren();
    badge.removeAttribute('title');
    badge.removeAttribute('aria-label');
    if (!state) return;
    const icon = document.createElement('span');
    icon.className = 'pnm-fit-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = state === 'fits' ? '✓' : state === 'not_listed' ? '−' : 'ⓘ';
    const text = document.createElement('span');
    text.className = 'pnm-fit-copy';
    const bikeName = bike ? bike.year + ' ' + bike.brand + ' ' + bike.model : '';
    if (state === 'fits' && labels.compact) {
      text.textContent = labels.fits_full.replace('__bike__', bikeName);
      badge.setAttribute('aria-label', text.textContent);
    } else if (state === 'fits') {
      const status = document.createElement('span');
      status.className = 'pnm-fit-label';
      status.textContent = labels.fits;
      const model = document.createElement('span');
      model.className = 'pnm-fit-bike';
      model.textContent = bikeName;
      text.append(status, model);
      badge.setAttribute('aria-label', labels.fits_full.replace('__bike__', bikeName));
    } else {
      text.textContent = labels[state].replace('__bike__', bikeName);
    }
    if (state === 'universal') {
      const note = document.createElement('span');
      note.className = 'pnm-fit-note';
      note.textContent = labels.confirm;
      text.appendChild(note);
    }
    if (state === 'fits' || state === 'not_listed') {
      badge.title = bike.brand + ' ' + bike.model + ' (' + bike.year + ')';
    }
    badge.append(icon, text);
  }

  function sync() {
    scheduled = false;
    const bike = selectedBike();
    document.querySelectorAll(cardSelector).forEach(card => updateCard(card, bike));
  }
  function schedule() {
    if (!scheduled) { scheduled = true; requestAnimationFrame(sync); }
  }
  function start() {
    sync();
    new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (!target || target.closest('[data-pnm-card-fitment]')) return false;
        if (target.closest('[data-pnm-bike-bar], [data-pnm-bike-parts]')) return true;
        if (record.type === 'attributes') return target.matches(cardSelector);
        return Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
          (node.matches(cardSelector) || node.querySelector(cardSelector)));
      })) schedule();
    }).observe(document.body, { subtree: true, childList: true, attributes: true,
      attributeFilter: ['href', 'hidden', 'data-pnm-fit-tags', 'data-pnm-cj360-fitment-review'] });
    window.addEventListener('globoFilterRenderCompleted', schedule);
    window.addEventListener('pageshow', schedule);
    window.addEventListener('storage', event => {
      if (event.key === 'pnm_selected_bike_v1' || event.key === null) schedule();
    });
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-category-filter-style"] && !Shopify.designMode) return;
  try {
    (() => {
  const configNode = document.querySelector('[data-pnm-sort-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const selector = '.sort-by-toggle, #globo-dropdown-sort_options';
  let scheduled = false;

  function repairLabel(element) {
    const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue.trim() === 'most_relevant') {
        node.nodeValue = node.nodeValue.replace('most_relevant', config.relevance);
      }
    }
    if (element.getAttribute('aria-label') === 'most_relevant') {
      element.setAttribute('aria-label', config.relevance);
    }
  }

  function sync() {
    scheduled = false;
    document.querySelectorAll('.gf-filter-selection .sort-by').forEach(sort => {
      const button = sort.querySelector('.sort-by-toggle');
      const list = sort.querySelector('#globo-dropdown-sort_options');
      if (!button || !list) return;
      repairLabel(button);
      if (button.getAttribute('data-pnm-sort-label') !== config.label) {
        button.setAttribute('data-pnm-sort-label', config.label);
      }
      const current = button.textContent.trim();
      const label = config.label + ': ' + current;
      if (button.getAttribute('aria-labelledby') === button.id) button.removeAttribute('aria-labelledby');
      if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
      list.querySelectorAll('[data-sort]').forEach(option => {
        repairLabel(option);
        const selected = option.textContent.trim() === current;
        if (option.classList.contains('pnm-sort-selected') !== selected) {
          option.classList.toggle('pnm-sort-selected', selected);
        }
        if (option.getAttribute('aria-selected') !== String(selected)) {
          option.setAttribute('aria-selected', String(selected));
        }
      });
    });
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  function start() {
    sync();
    new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (target?.closest(selector)) return true;
        return Array.from(record.addedNodes || []).some(node =>
          node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))
        );
      })) schedule();
    }).observe(document.body, {
      childList:true,
      characterData:true,
      subtree:true,
      attributes:true,
      attributeFilter:['aria-expanded', 'class']
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once:true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-cj360-card-test"] && !Shopify.designMode) return;
  try {
    (() => {
function initialize() {
  const configNode = document.querySelector('[data-pnm-cj360-card-test]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const selector = ':is(#gf-grid #gf-products, #collection-page) .product-card.pnm-card';
  const originals = new WeakMap();
  const normalize = value => String(value || '').trim().toUpperCase().replace(/\s+/g, ' ');
  const lines = value => Array.isArray(value) ? value.map(item => String(item).trim()) : String(value || '').replace(/\r/g, '').split('\n').map(item => item.trim());
  const universal = values => values.some(value => /\bUNIVERSAL\b/.test(normalize(value)));
  const products = new Map(config.products.map(product => {
    const brands = lines(product.brands), models = lines(product.models), years = lines(product.years);
    const aligned = brands.length === models.length && models.length === years.length;
    const validYears = aligned && !universal([...(product.tags || []), ...models])
      ? models.flatMap((model, index) => normalize(model) === 'CJ360' && normalize(brands[index]) === 'HONDA' && /^\d{4}$/.test(years[index]) ? [years[index]] : [])
      : [];
    return [product.handle, {...product, validYears}];
  }));
  let scheduled = false;

  function resultsContext(href) {
    const url = new URL(href);
    const path = decodeURIComponent(url.pathname);
    const collection = path.match(/\/collections\/([^/]+)(?:\/([^/]+))?\/?$/);
    if (!collection || collection[1] !== config.collection) return null;
    const tags = (collection[2] || '').split('+');
    if (universal(tags)) return null;
    if (tags.some(tag => /-\d{4}$/i.test(tag) && !/^cj360-\d{4}$/i.test(tag))) return null;
    const params = url.searchParams;
    if (['gff_705339','gff_705341','gff_705342'].some(key => params.getAll(key).length > 1)) return null;
    const model = normalize(params.get('gff_705341'));
    const brands = (params.get('gff_705339') || '').split(',').map(normalize);
    const selectedYear = params.get('gff_705342') || '';
    if (model && model !== 'CJ360') return null;
    if (params.has('gff_705339') && (!brands.includes('HONDA') || brands.some(brand => !['HONDA','HONDA - ATV','HONDA ATV'].includes(brand)))) return null;
    const modelTags = tags.filter(tag => /^cj360(?:-\d{4})?$/i.test(tag));
    const taggedYear = modelTags.find(tag => /^cj360-\d{4}$/i.test(tag))?.slice(-4) || '';
    if (modelTags.length > 1 || (selectedYear && taggedYear && selectedYear !== taggedYear)) return null;
    if (collection[1] !== 'honda-cj360-parts' && !(model === 'CJ360' && brands.includes('HONDA'))) return null;
    if (collection[1] !== 'honda-cj360-parts' && !modelTags.length) return null;
    const year = selectedYear || taggedYear;
    if (year && !['1976', '1977'].includes(year)) return null;
    return {year};
  }

  function restore(card, link) {
    const original = originals.get(link);
    if (!original) return;
    const host = link.querySelector('[data-pnm-card-link-text]') || link;
    host.replaceChildren(...original.nodes.map(node => node.cloneNode(true)));
    if (original.title === null) link.removeAttribute('title');
    else link.setAttribute('title', original.title);
    if (original.ariaLabel === null) link.removeAttribute('aria-label');
    else link.setAttribute('aria-label', original.ariaLabel);
    if (original.mobileSource === null) link.removeAttribute('data-pnm-mobile-source');
    else link.setAttribute('data-pnm-mobile-source', original.mobileSource);
    card.removeAttribute('data-pnm-cj360-pilot');
    if (card.hasAttribute('data-pnm-cj360-fitment-review')) {
      card.removeAttribute('data-pnm-cj360-fitment-review');
      card.querySelector('[data-pnm-card-fitment]')?.removeAttribute('data-pnm-fit-key');
    }
    originals.delete(link);
  }

  function enhance(card, context) {
    const link = card.querySelector('.product-title a[href]');
    if (!link) return;
    const url = new URL(link.getAttribute('href'), location.origin);
    const handle = url.origin === location.origin ? url.pathname.match(/\/products\/([^/]+)\/?$/)?.[1] : '';
    const product = products.get(handle);
    const liveTags = (card.getAttribute('data-pnm-fit-tags') || '').split('||');
    const eligible = context && product?.id && product.validYears.length && !universal(liveTags) &&
      (!context.year || product.validYears.includes(context.year));
    if (!eligible) { restore(card, link); return; }
    const signature = [product.handle, context.year, product.name, product.reference].join('|');
    if (card.getAttribute('data-pnm-cj360-pilot') === signature && link.querySelector('.pnm-cj360-card-name')) return;
    const host = link.querySelector('[data-pnm-card-link-text]') || link;
    if (!originals.has(link)) originals.set(link, {nodes:[...host.childNodes].map(node => node.cloneNode(true)), title:link.getAttribute('title'), ariaLabel:link.getAttribute('aria-label'), mobileSource:link.getAttribute('data-pnm-mobile-source')});
    const name = document.createElement('span');
    name.className = 'pnm-cj360-card-name';
    name.textContent = product.name;
    const reference = document.createElement('span');
    reference.className = 'pnm-cj360-card-reference';
    const number = document.createElement('strong');
    number.textContent = product.reference;
    reference.append((product.referenceOnly ? config.referenceLabel : config.oemLabel) + ' ', number);
    const nodes = [name];
    const accessible = [product.name];
    if (product.brand) {
      const brand = document.createElement('span');
      brand.className = 'pnm-cj360-card-brand';
      brand.textContent = product.brand;
      nodes.push(brand);
      accessible.push(product.brand);
    }
    if (product.detail) {
      const detail = document.createElement('span');
      detail.className = 'pnm-cj360-card-brand';
      detail.textContent = product.detail;
      nodes.push(detail);
      accessible.push(product.detail);
    }
    if (product.reference) {
      nodes.push(reference);
      accessible.push(reference.textContent);
    }
    host.replaceChildren(...nodes.flatMap((node, index) => index ? [document.createTextNode(' '), node] : [node]));
    link.setAttribute('aria-label', accessible.join(' '));
    link.setAttribute('title', accessible.join(' — '));
    card.setAttribute('data-pnm-cj360-pilot', signature);
    if (product.fitmentReview) {
      card.setAttribute('data-pnm-cj360-fitment-review', '');
      const badge = card.querySelector('[data-pnm-card-fitment]');
      if (badge) {
        badge.hidden = false;
        badge.dataset.fitState = 'review';
        badge.dataset.pnmFitKey = 'review|Honda|CJ360|' + context.year;
        badge.textContent = config.reviewLabel;
        badge.setAttribute('aria-label', config.reviewLabel);
        badge.removeAttribute('title');
      }
    }
  }

  function sync() {
    scheduled = false;
    let context = null;
    try { context = resultsContext(location.href); } catch (_) {}
    document.body.classList.toggle('pnm-cj360-mobile-list-test',
      config.collection === 'honda-cj360-parts' &&
      /^\/collections\/honda-cj360-parts(?:\/[^/]+)?\/?$/.test(location.pathname));
    document.querySelectorAll(selector).forEach(card => enhance(card, context));
  }

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  function start() {
    const root = document.getElementById('MainContent');
    if (root) new MutationObserver(records => {
      if (records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return !target?.closest('[data-pnm-card-fitment], .product-price, .product-actions') &&
          (target?.closest('.product-card') || [...record.addedNodes, ...record.removedNodes].some(node => node.nodeType === 1 && (node.matches('.product-card') || node.querySelector('.product-card'))));
      })) schedule();
    }).observe(root, {childList:true, subtree:true});
    ['pnm:browse-ready','pnm:bike-change','globoFilterRenderCompleted','popstate','pageshow'].forEach(event => window.addEventListener(event, schedule));
    document.addEventListener('shopify:section:load', schedule);
    sync();
  }

  start();
}
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-collection-browse-notice"] && !Shopify.designMode) return;
  try {
    (() => {
  const start = () => {
    const notice = document.querySelector('[data-pnm-browse-notice]');
    const configNode = document.querySelector('[data-pnm-browse-notice-config]');
    if (!notice || !configNode || notice.dataset.ready) return;
    notice.dataset.ready = 'true';
    const config = JSON.parse(configNode.textContent);
    let queued = false;
    const sync = () => {
      queued = false;
      const api = window.PNMCollectionYear;
      const scope = api?.context();
      const savedLink = document.querySelector('[data-pnm-bike-parts]:not([hidden])[href]');
      if (!scope || !savedLink) { notice.hidden = true; return; }
      let url, saved;
      try {
        url = new URL(savedLink.getAttribute('href'), location.origin);
        if (url.origin !== location.origin || !url.pathname.includes('/collections/')) { notice.hidden = true; return; }
        saved = api.context(url.pathname, url.searchParams)?.bike;
      } catch (_) { notice.hidden = true; return; }
      if (!saved) { notice.hidden = true; return; }
      const candidates = scope.bike ? [scope.bike] : scope.models;
      const match = candidates.find(model => model.key === saved.key && (!saved.bikeYear || model.years.includes(saved.bikeYear)));
      const sameYear = !scope.bike?.bikeYear || scope.bike.bikeYear === saved.bikeYear;
      if (match && sameYear) { notice.hidden = true; return; }
      const label = [saved.bikeYear, saved.brand, saved.modelDisplay || saved.modelType].filter(Boolean).join(' ');
      const heading = notice.querySelector('[data-pnm-notice-heading]');
      const copy = notice.querySelector('[data-pnm-notice-copy]');
      if (heading.textContent !== config.browsing) heading.textContent = config.browsing;
      const text = config.saved.replace('__bike__', label);
      if (copy.textContent !== text) copy.textContent = text;
      const target = notice.querySelector('[data-pnm-notice-saved]');
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) url.searchParams.set('preview_theme_id', preview);
      target.href = url.pathname + url.search + url.hash;
      notice.hidden = false;
    };
    const schedule = () => { if (!queued) { queued = true; queueMicrotask(sync); } };
    notice.querySelector('[data-pnm-notice-choose]').addEventListener('click', () => {
      const choices = document.querySelector('.pnm-catalog-models');
      const year = document.querySelector('#pnm-collection-year');
      const panel = [choices,year].find(node => node && node.getClientRects().length && getComputedStyle(node).display !== 'none');
      if (panel) {
        const editor = panel.querySelector('details');
        if (editor) editor.open = true;
        panel.scrollIntoView({block:'center',behavior:'auto'});
        const focus = panel.querySelector('select:not(:disabled),.pnm-model-year>summary,a[href]');
        focus?.focus({preventScroll:true});
      } else {
        document.querySelector('[data-pnm-bike-bar] [data-pnm-bike-open]')?.click();
      }
    });
    ['pnm:bike-change','pnm:browse-ready','globoFilterRenderCompleted','popstate','pageshow'].forEach(event => window.addEventListener(event,schedule));
    const bar = document.querySelector('[data-pnm-bike-bar]');
    if (bar) new MutationObserver(schedule).observe(bar,{subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['href','hidden']});
    schedule();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-collection-jump"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.pnmCollectionJumpReady) return;
    window.pnmCollectionJumpReady = true;
    document.addEventListener('click', event => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const link = event.target.closest('a[data-pnm-scroll-target]');
      if (!link) return;
      const target = document.getElementById(link.dataset.pnmScrollTarget);
      if (!target) return;
      event.preventDefault();
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
      target.scrollIntoView({ block: 'start', behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-collection-model-search"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalize = value => String(value || '').toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\b(honda|yamaha|kawasaki|suzuki|parts|motorcycle|motorcycles)\b/g, ' ')
    .replace(/\bgold\s+wing\b/g, 'goldwing')
    .replace(/\b([a-z]+)\s+(?=\d)/g, '$1')
    .replace(/(\d)\s+([a-z]{1,2})\b/g, '$1$2')
    .trim().replace(/\s+/g, ' ');
  const matchScore = (label, query) => {
    if (!query) return 0;
    if (label === query) return 0;
    const words = label.split(' ');
    if (words.includes(query)) return 1;
    if (label.startsWith(query)) return 2;
    return query.split(' ').every(token => words.some(word => word.startsWith(token))) ? 3 : Infinity;
  };
  const initialize = () => document.querySelectorAll('[data-pnm-model-search]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const input = root.querySelector('input');
    const form = root.querySelector('[data-model-search-form]');
    const clear = root.querySelector('[data-model-search-clear]');
    const browse = root.querySelector('[data-model-search-browse]');
    const label = root.querySelector('[data-model-search-label]');
    const status = root.querySelector('[data-model-search-status]');
    const empty = root.querySelector('[data-model-search-empty]');
    const list = root.querySelector('.pnm-model-search__list');
    const links = [...list.querySelectorAll('[data-model-search-link]')].map(element => ({ element, term: normalize(element.dataset.modelLabel), family: normalize(element.dataset.modelFamily || '') }));
    const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
    links.sort((a, b) => collator.compare(a.term, b.term));
    links.forEach(link => list.append(link.element));
    let searching = false;
    let wasOpen = false;
    const filter = () => {
      const term = normalize(input.value);
      if (term && !searching) wasOpen = browse.open;
      let count = 0;
      links.forEach(link => {
        const directScore = matchScore(link.term, term);
          const familyScore = matchScore(link.family, term);
          link.score = Math.min(directScore, Number.isFinite(familyScore) ? familyScore + 4 : Infinity);
          const match = Number.isFinite(link.score);
        link.element.hidden = !match;
        if (match) count += 1;
      });
      links.sort((a, b) => (a.score - b.score || collator.compare(a.term, b.term)));
      links.forEach(link => list.append(link.element));
      clear.hidden = !input.value;
      empty.hidden = !term || count > 0;
      list.hidden = Boolean(term) && count === 0;
      status.textContent = term ? (count === 1 ? root.dataset.resultOne : root.dataset.resultMany.replace('999999', String(count))) : '';
      label.textContent = term ? label.dataset.results : label.dataset.default;
      if (term) browse.open = true;
      else if (searching) browse.open = wasOpen;
      searching = Boolean(term);
    };
    input.addEventListener('input', filter);
    input.addEventListener('search', filter);
    input.addEventListener('keydown', event => {
      if (event.key === 'Escape' && input.value) {
        event.preventDefault(); input.value = ''; filter();
      }
    });
    clear.addEventListener('click', () => { input.value = ''; filter(); input.focus(); });
    form.addEventListener('submit', event => {
      event.preventDefault(); filter(); browse.open = true;
      links.find(link => !link.element.hidden)?.element.querySelector('a').focus();
    });
    form.hidden = false;
    filter();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-collection-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
    document.addEventListener('click', event => {
      const trigger = event.target.closest('[data-pnm-desktop-brand-selector]');
      if (!trigger || window.innerWidth <= 1024 || trigger.closest('.site-nav-mobile') || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.defaultPrevented) return;
      if (typeof window.PNMBikeSelector?.open !== 'function') return;
      event.preventDefault();
      event.stopPropagation();
      window.PNMBikeSelector.open(trigger);
    }, true);
    const roots = [...document.querySelectorAll('[data-pnm-nav]')];
    if (!roots.length) return;
    let closeTimer, familyTimer;
    const desktop = root => !root.closest('.site-nav-mobile') && window.innerWidth > 1024;
    const normalize = value => value.toLowerCase().replace(/[^a-z0-9]/g, '');
    function closeModels(root) {
      clearTimeout(familyTimer);
      root.querySelectorAll('.pnm-model-panel').forEach(panel => { panel.hidden = true; });
      root.querySelectorAll('.pnm-family-toggle').forEach(button => button.setAttribute('aria-expanded', 'false'));
      root.querySelectorAll('.pnm-selected').forEach(row => row.classList.remove('pnm-selected'));
      root.querySelector('.pnm-nav-panel')?.classList.remove('pnm-models-open');
    }
    function close(root) {
      delete root.dataset.pnmFamilyPinned;
      const panel = root.querySelector('.pnm-nav-panel');
      if (panel) panel.hidden = true;
      root.classList.remove('pnm-open');
      root.querySelector('.pnm-root-toggle')?.setAttribute('aria-expanded', 'false');
      closeModels(root);
    }
    function place(root) {
      const panel = root.querySelector('.pnm-nav-panel');
      if (!panel || !desktop(root)) return;
      panel.style.left = '0px';
      const group = root.closest('.pnm-nav-brand-group');
      const nav = root.closest('#site-nav');
      const lowerEdge = group ? group.getBoundingClientRect().bottom : nav.getBoundingClientRect().bottom;
      panel.style.top = `${lowerEdge - root.getBoundingClientRect().top}px`;
      root.style.setProperty('--pnm-hover-bridge', `${Math.max(0, lowerEdge - root.getBoundingClientRect().bottom) + 3}px`);
      const rect = panel.getBoundingClientRect();
      const shift = Math.min(0, document.documentElement.clientWidth - rect.right - 12);
      panel.style.left = `${Math.max(12 - rect.left, shift)}px`;
      panel.style.setProperty('--pnm-list-height', `${Math.max(120, Math.min(420, window.innerHeight - rect.top - 140))}px`);
    }
    function open(root) {
      clearTimeout(closeTimer);
      roots.filter(other => other !== root).forEach(close);
      const panel = root.querySelector('.pnm-nav-panel');
      if (!panel) return;
      panel.hidden = false;
      root.classList.add('pnm-open');
      root.querySelector('.pnm-root-toggle')?.setAttribute('aria-expanded', 'true');
      place(root);
    }
    function openModels(root, button) {
      const target = document.getElementById(button.getAttribute('aria-controls'));
      if (!target) return;
      closeModels(root);
      target.hidden = false;
      button.setAttribute('aria-expanded', 'true');
      button.closest('.pnm-family-row').classList.add('pnm-selected');
      const panel = root.querySelector('.pnm-nav-panel');
      panel.classList.add('pnm-models-open');
      if (desktop(root)) {
        const panelRect = panel.getBoundingClientRect();
        const rowRect = button.getBoundingClientRect();
        target.style.left = panelRect.right + target.offsetWidth > document.documentElement.clientWidth - 12 ? `${-target.offsetWidth}px` : '100%';
        const available = window.innerHeight - 84;
        const top = Math.max(0, Math.min(rowRect.top - panelRect.top, available - panelRect.top - target.offsetHeight));
        target.style.top = `${top}px`;
      } else {
        target.querySelector('.pnm-model-back').focus();
      }
    }
    roots.forEach(root => {
      root.querySelector('.pnm-root-toggle')?.addEventListener('click', () => {
        if (!desktop(root) && root.classList.contains('pnm-open')) close(root); else open(root);
      });
      root.addEventListener('pointerenter', event => {
        if (desktop(root) && event.pointerType !== 'touch') open(root);
      });
      root.addEventListener('pointerleave', event => {
        if (desktop(root) && event.pointerType !== 'touch') closeTimer = setTimeout(() => close(root), 220);
      });
      root.querySelectorAll('.pnm-family-row').forEach(row => {
        const button = row.querySelector('.pnm-family-toggle');
        row.addEventListener('pointerenter', event => {
          if (!desktop(root) || event.pointerType === 'touch' || root.dataset.pnmFamilyPinned) return;
          clearTimeout(familyTimer);
          familyTimer = setTimeout(() => {
            if (button) openModels(root, button); else closeModels(root);
          }, 180);
        });
        row.addEventListener('pointerleave', () => clearTimeout(familyTimer));
        button?.addEventListener('click', event => {
          clearTimeout(familyTimer);
          root.dataset.pnmFamilyPinned = 'true';
          if (!desktop(root) && button.getAttribute('aria-expanded') === 'true') closeModels(root);
          else {
            openModels(root, button);
            if (desktop(root) && event.detail === 0) document.getElementById(button.getAttribute('aria-controls')).querySelector('a')?.focus();
          }
        });
      });
      root.querySelectorAll('.pnm-model-back').forEach(button => button.addEventListener('click', () => {
        const active = root.querySelector('.pnm-family-toggle[aria-expanded="true"]');
        closeModels(root);
        active?.focus();
      }));
      root.querySelector('.pnm-family-list')?.addEventListener('scroll', () => { if (desktop(root) && !root.dataset.pnmFamilyPinned) closeModels(root); });
      root.querySelector('.pnm-nav-search')?.addEventListener('input', event => {
        closeModels(root);
        const query = normalize(event.target.value);
        const rows = [...root.querySelectorAll('.pnm-family-row')];
        rows.forEach(row => { row.hidden = !normalize(row.dataset.search).includes(query); });
        root.querySelector('.pnm-no-results').hidden = rows.some(row => !row.hidden);
      });
      root.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        event.preventDefault();
        const active = root.querySelector('.pnm-family-toggle[aria-expanded="true"]');
        if (active) { closeModels(root); active.focus(); }
        else { close(root); root.querySelector('.pnm-root-toggle')?.focus(); }
      });
      root.addEventListener('focusout', event => { if (!root.contains(event.relatedTarget)) close(root); });
    });
    document.addEventListener('click', event => { if (!event.target.closest('[data-pnm-nav]')) roots.forEach(close); });
    window.addEventListener('resize', () => roots.forEach(close));
    const nav = roots[0].parentElement;
    new MutationObserver(() => roots.forEach(close)).observe(nav, { attributes:true, attributeFilter:['class'] });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-collection-sidebar-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  const configNode = document.querySelector('[data-pnm-collection-navigation-config]');
  const nav = document.querySelector('[data-pnm-main-categories]');
  if (!configNode || !nav) return;
  const config = JSON.parse(configNode.textContent);
  const overview = document.querySelector('[data-pnm-collection-overview]');
  const overviewHeading = overview?.querySelector('[data-pnm-overview-heading]');
  const mobile = matchMedia('(max-width:767px)');
  const panel = document.createElement('div');
  panel.className = 'pnm-part-type';
  panel.hidden = true;
  const label = document.createElement('span');
  label.className = 'pnm-part-type__label';
  label.id = 'pnm-part-type-label';
  label.textContent = config.partType;
  const labelRow = document.createElement('div');
  labelRow.className = 'pnm-part-type__heading';
  const clear = document.createElement('a');
  clear.className = 'pnm-part-type-clear';
  clear.textContent = config.clear;
  clear.setAttribute('aria-label',config.clearLabel);
  clear.hidden = true;
  labelRow.append(label,clear);
  const select = document.createElement('select');
  select.id = 'pnm-part-type-select';
  select.hidden = true;
  select.tabIndex = -1;
  const trigger = document.createElement('button');
  trigger.type = 'button';
  trigger.className = 'pnm-subcategory-trigger';
  trigger.setAttribute('aria-expanded','false');
  trigger.setAttribute('aria-controls','pnm-subcategory-options');
  trigger.setAttribute('aria-labelledby',label.id + ' pnm-subcategory-value');
  const currentValue = document.createElement('span');
  currentValue.id = 'pnm-subcategory-value';
  const chevron = document.createElement('span');
  chevron.className = 'pnm-subcategory-chevron';
  chevron.setAttribute('aria-hidden','true');
  trigger.append(currentValue,chevron);
  const menu = document.createElement('ul');
  menu.id = 'pnm-subcategory-options';
  menu.className = 'pnm-subcategory-options';
  menu.setAttribute('aria-labelledby',label.id);
  menu.hidden = true;
  panel.append(labelRow,trigger,menu,select);
  function closeMenu(restoreFocus = false) {
    menu.hidden = true;
    trigger.setAttribute('aria-expanded','false');
    if (restoreFocus) trigger.focus();
  }
  trigger.addEventListener('click',() => {
    if (!menu.hidden) { closeMenu(); return; }
    const rect = trigger.getBoundingClientRect();
    const below = innerHeight - rect.bottom - 16;
    const above = rect.top - 16;
    const opensUp = below < 180 && above > below;
    panel.dataset.opensUp = String(opensUp);
    menu.style.maxHeight = Math.min(420,Math.max(120,opensUp ? above : below)) + 'px';
    menu.hidden = false;
    trigger.setAttribute('aria-expanded','true');
  });
  panel.addEventListener('keydown',event => {
    if (event.key === 'Escape' && !menu.hidden) {
      event.preventDefault(); event.stopPropagation(); closeMenu(true);
    }
  });
  panel.addEventListener('focusout',() => requestAnimationFrame(() => {
    if (!panel.contains(document.activeElement)) closeMenu();
  }));
  document.addEventListener('click',event => { if (!panel.contains(event.target)) closeMenu(); });
  window.addEventListener('resize',() => closeMenu());
  function syncMenu() {
    trigger.disabled = select.disabled;
    const selected = select.selectedOptions[0];
    currentValue.textContent = selected?.dataset.label || selected?.textContent || config.partType;
    panel.dataset.selected = String(Boolean(select.value && !select.value.startsWith('__')));
    panel.dataset.filterId = selectionMode?.kind === 'native' ? selectionMode.id : '';
    const clearTarget = selectionURL('');
    clear.hidden = select.disabled || !select.value || !clearTarget;
    if (clearTarget) clear.href = relative(clearTarget);
    const fragment = document.createDocumentFragment();
    [...select.options].filter(option => !option.disabled && !option.value.startsWith('__')).forEach(option => {
      const target = selectionURL(option.value);
      if (!target) return;
      const item = document.createElement('li');
      const link = document.createElement('a');
      link.href = relative(target);
      const name = document.createElement('span');
      name.textContent = option.dataset.label || option.textContent;
      link.append(name);
      if (option.dataset.count !== undefined) {
        const count = document.createElement('span');
        count.className = 'pnm-subcategory-count';
        count.textContent = option.dataset.count;
        link.append(count);
      }
      if (option.selected) link.setAttribute('aria-current','page');
      item.append(link); fragment.append(item);
    });
    menu.replaceChildren(fragment);
    if (select.disabled) closeMenu();
    window.dispatchEvent(new Event('pnm:part-type-ready'));
  }
  if (!nav.querySelector('.pnm-sidebar-category-title')) {
    const title = document.createElement('h2');
    title.className = 'pnm-sidebar-category-title';
    const symbol = nav.querySelector('.pnm-main-categories__symbol')?.cloneNode(true);
    if (symbol) title.append(symbol);
    const titleText = document.createElement('span');
    titleText.textContent = config.category;
    title.append(titleText);
    nav.prepend(title);
  }
  const slug = value => value.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'').replace(/[^a-z0-9]+/g,'-').replace(/^-|-$/g,'');
  const base = path => path.match(/^.*?\/collections\/[^/]+/)?.[0] || path;
  const relative = url => url.pathname + url.search + url.hash;
  const nativeGroups = () => [...document.querySelectorAll('#gf-tree [data-filter-id]')].filter(group => group.dataset.filterType === 'Tag' && group.dataset.filterId !== '852978' && group.querySelector('[data-fvalue]'));
  let sidebar = nav.closest('.pnm-collection-sidebar'), scheduled = false, selectionMode = null, requestKey = '', requestValue = null, requestController = null, retryAt = 0;
  const metadata = new Map();
  const counts = new Map();
  function selectedCategory() {
    const selected = nav.querySelector('a[data-category][aria-current="page"]')?.dataset.category;
    return config.categories.find(category => category.label === selected);
  }
  const directChild = category => category.children.find(child => base(new URL(child.url,location.origin).pathname) === base(location.pathname));
  function clearPartType(url) {
    const old = url.searchParams.get('pnm_part_type');
    if (old) {
      const root = base(url.pathname);
      const tags = url.pathname.slice(root.length + 1).split('+').filter(tag => tag && tag !== old);
      url.pathname = root + (tags.length ? '/' + tags.join('+') : '');
    }
    url.searchParams.delete('pnm_part_type');
    nativeGroups().forEach(group => url.searchParams.delete('gf_' + group.dataset.filterId));
    url.searchParams.delete('page');
    url.searchParams.delete('gf_page');
    return url;
  }
  function renderOptions(category, values, mode, active, loading = false) {
    const signature = JSON.stringify({category:category.label,values,active,loading,mode,url:location.pathname+location.search});
    selectionMode = mode;
    if (select.dataset.signature === signature) return;
    panel.hidden = false;
    select.dataset.signature = signature;
    const reset = new Option(config.allParts.replace('[category]',category.label),'');
    const options = [reset];
    if (loading) options.push(new Option(config.loading,'__loading'));
    if (active.length > 1) {
      const multiple = new Option(config.multiple,'__multiple');
      multiple.disabled = true;
      options.push(multiple);
    }
    values.forEach(item => {
      if (!item.value || !Number.isInteger(item.count) || item.count <= 0) return;
      const option = new Option(item.label + (Number.isInteger(item.count) ? ' (' + item.count + ')' : ''),item.value);
      option.dataset.label = item.label;
      if (Number.isInteger(item.count)) option.dataset.count = String(item.count);
      options.push(option);
    });
    active.filter(value => !options.some(option => option.value === value)).forEach(value => {
      const child = category.children.find(item => slug(item.label) === value);
      const unavailable = new Option(child?.label || values.find(item => item.value === value)?.label || value,value);
      unavailable.disabled = true;
      unavailable.hidden = true;
      options.push(unavailable);
    });
    select.replaceChildren(...options);
    select.disabled = loading;
    select.value = loading ? '__loading' : active.length > 1 ? '__multiple' : active[0] || '';
    if (select.selectedIndex < 0) select.value = '';
    syncMenu();
    if (!loading && !active.length && options.length === 1) { closeMenu(); panel.hidden = true; }
  }
  async function remoteTypes(category, key, controller) {
    const embed = window.GloboEmbedFilterConfig;
    if (!embed?.api?.url || !embed?.shop?.domain) throw new Error('Filter unavailable');
    const categoryPath = base(new URL(category.url,location.origin).pathname);
    let filterId = base(location.pathname) === categoryPath ? embed.filter?.id : metadata.get(category.url);
    if (!filterId) {
      const target = new URL(category.url,location.origin);
      if (target.origin !== location.origin) throw new Error('Invalid category');
      const response = await fetch(target.href,{signal:controller.signal});
      if (!response.ok) throw new Error('Category unavailable');
      const html = await response.text();
      const match = html.match(/filter:\s*\{\s*id:\s*(\d+)/);
      if (!match) throw new Error('Filter unavailable');
      filterId = match[1];
      metadata.set(category.url,filterId);
    }
    const endpoint = new URL('/api/apiFilter',embed.api.url);
    if (endpoint.protocol !== 'https:') throw new Error('Invalid filter');
    endpoint.searchParams.set('shop',embed.shop.domain);
    endpoint.searchParams.set('filter_id',filterId);
    endpoint.searchParams.set('collection',String(directChild(category) && category.id ? category.id : config.collectionId));
    endpoint.searchParams.set('page','1');
    endpoint.searchParams.set('limit','1');
    endpoint.searchParams.set('event','init');
    endpoint.searchParams.set('page_type','collection');
    endpoint.searchParams.set('form[852978][]',category.label);
    const current = new URL(location.href);
    const old = current.searchParams.get('pnm_part_type');
    const scopeTags = new Set((embed.collection?.tags || []).filter(tag => slug(tag) !== old));
    const pathTags = clearPartType(new URL(current.href)).pathname.slice(base(current.pathname).length + 1).split('+');
    if (pathTags.includes(slug(category.label))) scopeTags.add(category.label);
    const model = current.searchParams.get('gff_705341');
    const year = current.searchParams.get('gff_705342');
    const bikeTag = model ? model + (year ? ' (' + year + ')' : '') : '';
    if (bikeTag && pathTags.includes(slug(bikeTag))) scopeTags.add(bikeTag);
    if (pathTags.includes('universal')) scopeTags.add('Universal');
    scopeTags.forEach(tag => endpoint.searchParams.append('currentTags[]',tag));
    const filters = Object.fromEntries([...current.searchParams].filter(([name]) => /^gff_/.test(name)));
    const fitment = window.pnmFitmentParams?.(filters) || filters;
    Object.entries(fitment).forEach(([name,value]) => (Array.isArray(value) ? value : [value]).forEach(item => endpoint.searchParams.append('form[' + name.slice(4) + '][]',item)));
    if (current.searchParams.get('q')) endpoint.searchParams.set('q',current.searchParams.get('q'));
    if (window.currentCountry) endpoint.searchParams.set('country',window.currentCountry);
    if (window.currentCurrency) endpoint.searchParams.set('currency',window.currentCurrency);
    if (window.currentLanguageCode) endpoint.searchParams.set('locale',window.currentLanguageCode);
    const response = await fetch(endpoint.href,{credentials:'omit',signal:controller.signal});
    if (!response.ok) throw new Error('Part types unavailable');
    const data = await response.json();
    const childTags = new Set(category.children.map(child => slug(child.label)));
    const facet = data.filters?.find(group => String(group.id) !== '852978' && Array.isArray(group.values) && group.values.some(item => typeof item.value === 'string' && childTags.has(slug(item.value))));
    if (!facet && Number(data.pagination?.total) !== 0) throw new Error('Part types unavailable');
    const values = (facet?.values || []).filter(item => typeof item.value === 'string' && item.count != null).map(item => ({value:slug(item.value),label:item.value,count:Number(item.count)})).filter(item => Number.isInteger(item.count) && item.count > 0);
    if (controller.signal.aborted || requestKey !== key) return;
    requestValue = values;
    counts.set(key,values);
    if (counts.size > 8) counts.delete(counts.keys().next().value);
    schedule();
  }
  function syncPartType(category) {
    document.querySelectorAll('#gf-tree [data-pnm-navigation-replaced]').forEach(group => group.removeAttribute('data-pnm-navigation-replaced'));
    document.querySelector('#gf-tree [data-filter-id="852978"]')?.setAttribute('data-pnm-navigation-replaced','true');
    if (!category) { panel.hidden = true; requestController?.abort(); requestKey = ''; requestValue = null; return; }
    const groups = nativeGroups();
    const child = directChild(category);
    const tagged = new URLSearchParams(location.search).get('pnm_part_type');
    if (groups.length === 1 && !child && !tagged) {
      requestController?.abort(); requestController = null; requestKey = ''; requestValue = null;
      const group = groups[0];
      const buttons = [...group.querySelectorAll('[data-fvalue][role="checkbox"]')];
      const values = buttons.map(button => ({value:button.dataset.fvalue,label:button.querySelector('.gf-label')?.textContent.trim() || button.dataset.fvalue,count:Number(button.querySelector('.gf-count')?.textContent.replace(/[^0-9]/g,''))}));
      const active = buttons.filter(button => button.getAttribute('aria-checked') === 'true').map(button => button.dataset.fvalue);
      renderOptions(category,values,{kind:'native',id:group.dataset.filterId},active);
      group.dataset.pnmNavigationReplaced = 'true';
      return;
    }
    const active = tagged || (child ? slug(child.label) : '');
    const unfiltered = clearPartType(new URL(location.href));
    const key = config.collectionId + '|' + category.label + '|' + unfiltered.pathname + unfiltered.search;
    if (key !== requestKey) {
      requestController?.abort(); requestController = null; requestKey = key; retryAt = 0;
      requestValue = counts.get(key) || null;
    }
    renderOptions(category,requestValue || [],{kind:'tag'},active ? [active] : [],!requestValue && !retryAt);
    if (groups.length === 1) groups[0].dataset.pnmNavigationReplaced = 'true';
    if (requestValue || requestController || Date.now() < retryAt) return;
    const controller = new AbortController();
    requestController = controller;
    const timeout = setTimeout(() => controller.abort(),15000);
    remoteTypes(category,key,controller).catch(() => {
      if (requestKey !== key) return;
      retryAt = Date.now() + 30000;
      renderOptions(category,[],{kind:'tag'},active ? [active] : []);
    }).finally(() => { clearTimeout(timeout); if (requestController === controller) requestController = null; });
  }
  const bikeHeader=document.createElement('button');
  bikeHeader.type='button';
  bikeHeader.className='pnm-sidebar-bike';
  bikeHeader.setAttribute('aria-haspopup','dialog');
  bikeHeader.setAttribute('aria-controls','pnm-model-dialog');
  const bikeTitle=document.createElement('strong'),bikeHint=document.createElement('span');
  bikeHeader.append(bikeTitle,bikeHint);
  bikeHeader.addEventListener('click',()=>window.PNMBikeSelector?.open?.(bikeHeader));
  function syncBikeHeader(){
    if(!sidebar)return;
    const existing=sidebar.querySelector('.pnm-collection-year');
    bikeHeader.hidden=Boolean(existing);
    if(bikeHeader.parentElement!==sidebar)sidebar.prepend(bikeHeader);
    const bike=window.PNMBikeSelector?.selection?.();
    const brand=String(bike?.brand||'').split(',')[0].replace(/ - ATV$/,'').trim();
    const title=bike?.model?[bike.year,brand,bike.model].filter(Boolean).join(' '):config.selectBike;
    const hint=bike?.model?config.changeBike:config.findParts;
    if(bikeTitle.textContent!==title)bikeTitle.textContent=title;
    if(bikeHint.textContent!==hint)bikeHint.textContent=hint;
  }
  function sync() {
    scheduled = false;
    const grid = document.getElementById('gf-grid');
    const root = document.getElementById('CollectionProductGrid');
    if (!grid || !root || !root.contains(grid)) return;
    if (!sidebar) {
      sidebar = document.createElement('aside'); sidebar.className = 'pnm-collection-sidebar';
      sidebar.setAttribute('aria-label',config.heading);
    }
    if (sidebar.parentElement !== root) root.insertBefore(sidebar,grid);
    if (nav.parentElement !== sidebar) sidebar.append(nav);
    const tree = document.getElementById('gf-tree');
    if (tree && tree.parentElement !== sidebar) sidebar.prepend(tree);
    document.body.classList.add('pnm-sidebar-navigation');
    const heading = nav.querySelector('[data-pnm-mobile-heading]')?.textContent || config.heading;
    const text = nav.dataset.hasBike === 'true' ? heading : config.heading;
    if (overviewHeading && overviewHeading.textContent !== text) overviewHeading.textContent = text;
    const controls = grid.querySelector('#gf-controls-container');
    const actions = controls?.querySelector('.gf-actions');
    const searchActions = actions?.querySelector('.pnm-search-actions');
    if (searchActions) {
      if (panel.parentElement !== searchActions) searchActions.prepend(panel);
    } else if (controls && actions && panel.previousElementSibling !== actions) actions.after(panel);
    syncBikeHeader();
    syncPartType(selectedCategory());
    if (tree) tree.dataset.pnmEmpty = String(![...tree.querySelectorAll('.gf-filter-contents > *')].some(node => !node.hidden && node.dataset.pnmNavigationReplaced !== 'true'));
  }
  function schedule() { if (!scheduled) { scheduled = true; requestAnimationFrame(sync); } }
  function selectionURL(value) {
    if (!selectionMode || value.startsWith('__')) return null;
    const target = clearPartType(new URL(location.href));
    const category = selectedCategory();
    if (category && directChild(category)) {
      const anchor = [...nav.querySelectorAll('a[data-category]')].find(link => link.dataset.category === category.label);
      const parent = window.PNMBikeBrowse?.destination(anchor);
      if (parent) target.pathname = parent.pathname;
    }
    if (selectionMode.kind === 'native') {
      if (value) target.searchParams.set('gf_' + selectionMode.id,value);
      const direct = category?.children.find(child => base(new URL(child.url,location.origin).pathname) === base(location.pathname));
      if (direct && category) {
        const anchor = [...nav.querySelectorAll('a[data-category]')].find(link => link.dataset.category === category.label);
        const parent = window.PNMBikeBrowse?.destination(anchor);
        if (parent) target.pathname = parent.pathname;
      }
    } else if (value) {
      const root = base(target.pathname);
      const tags = target.pathname.slice(root.length + 1).split('+').filter(Boolean);
      if (!tags.includes(value)) tags.push(value);
      target.pathname = root + '/' + tags.join('+');
      target.searchParams.set('pnm_part_type',value);
    }
    target.hash = window.matchMedia('(min-width:768px)').matches ? 'CollectionProductGrid' : 'gf-controls-container';
    return target;
  }
  select.addEventListener('change',() => {
    const target = selectionURL(select.value);
    if (target) location.assign(relative(target));
  });
  const start = () => {
    sync();
    const root = document.getElementById('MainContent');
    if (!root) return;
    new MutationObserver(records => {
      if (records.some(record => record.type === 'attributes' || [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches('#gf-grid,#gf-tree,[data-filter-id],.gf-actions,.pnm-search-actions') || node.querySelector('#gf-grid,#gf-tree,[data-filter-id],.gf-actions,.pnm-search-actions'))))) schedule();
    }).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-checked']});
  };
  ['pnm:browse-ready','pnm:bike-change','globoFilterRenderCompleted','popstate','pageshow'].forEach(event => window.addEventListener(event,schedule));
  mobile.addEventListener('change',schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-collection-ux"] && !Shopify.designMode) return;
  try {
    (() => {
  const configNode=document.querySelector('[data-pnm-collection-ux-config]');
  if(!configNode)return;
  const labels=JSON.parse(configNode.textContent);
  const excluded=new Set(['705339','705340','705341','705342','852962','select-your-model']);
  let scheduled=false;
  const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(sync);}};
  const blocks=()=>[...document.querySelectorAll('#gf-tree [data-filter-id]')].filter(block=>!excluded.has(block.dataset.filterId));
  const clearURL=()=>{
    const url=new URL(location.href);
    blocks().forEach(block=>url.searchParams.delete('gf_'+block.dataset.filterId));
    url.searchParams.delete('page');url.hash='gf-controls-container';
    return url.pathname+url.search+url.hash;
  };
  function sync(){
    scheduled=false;
    const bike=window.PNMCollectionYear?.context()?.bike;
    const editor=document.querySelector('.pnm-model-options-editor');
    if(editor){
      const hasBike=Boolean(bike?.bikeYear);
      const key=[bike?.key,bike?.bikeYear].join('|');
      if(editor.dataset.selection!==key){
        editor.dataset.selection=key;
        editor.dataset.hasBike=String(hasBike);
        editor.open=!hasBike;
      }
      const value=editor.querySelector('[data-pnm-model-options-current]');
      const text=hasBike?[bike.bikeYear,bike.brand,bike.modelDisplay||bike.modelType].join(' '):'';
      if(value.textContent!==text)value.textContent=text;
    }
    const controls=document.querySelector('#gf-controls-container');
    if(!controls)return;
    const nativeFilter=controls.querySelector('.gf-refine-toggle-mobile button');
    if(nativeFilter&&!nativeFilter.dataset.pnmCompactLabel){
      [...nativeFilter.childNodes].filter(node=>node.nodeType===3).forEach(node=>node.remove());
      nativeFilter.append(document.createTextNode(' '+labels.filter));
      nativeFilter.setAttribute('aria-label',labels.filter);
      nativeFilter.dataset.pnmCompactLabel='true';
    }
    const activeCategory=document.querySelector('.pnm-collection-sidebar [data-category][aria-current="page"]')?.dataset.category;
    const partType=controls.querySelector('.pnm-part-type:not([hidden])');
    const integratedClear=partType?.querySelector('.pnm-part-type-clear:not([hidden])');
    const integratedId=integratedClear?.href&&partType.querySelector('select')?.value!=='__multiple'?partType.dataset.filterId:'';
    const options=blocks().flatMap(block=>[...block.querySelectorAll('[role="checkbox"][aria-checked="true"]')].map(option=>({id:block.dataset.filterId,value:option.dataset.fvalue,label:option.querySelector('.gf-label')?.textContent.trim()||option.getAttribute('aria-label')}))).filter(option=>option.value&&option.label&&option.id!==integratedId&&!(option.id==='852978'&&option.value===activeCategory));
    let chips=controls.querySelector('.pnm-active-filters');
    if(!chips){
      chips=document.createElement('nav');
      chips.className='pnm-active-filters';
      chips.setAttribute('aria-label',labels.active);
      controls.append(chips);
    }
    const signature=JSON.stringify(options)+location.search+'|'+integratedId;
    if(chips.dataset.signature===signature)return;
    chips.dataset.signature=signature;
    chips.hidden=!options.length;
    controls.classList.toggle('pnm-ux-filters',Boolean(options.length)||Boolean(integratedId));
    chips.replaceChildren();
    options.forEach(option=>{
      const button=document.createElement('button');
      button.type='button';button.className='pnm-filter-chip';
      button.setAttribute('aria-label',labels.remove.replace('__filter__',option.label));
      const name=document.createElement('span');name.textContent=option.label;
      const close=document.createElement('span');close.textContent='×';close.setAttribute('aria-hidden','true');
      button.append(name,close);
      button.addEventListener('click',()=>{
        const block=blocks().find(item=>item.dataset.filterId===option.id);
        const current=[...(block?.querySelectorAll('[role="checkbox"]')||[])].find(item=>item.dataset.fvalue===option.value);
        if(current?.getAttribute('aria-checked')==='true')current.click();
      });
      chips.append(button);
    });
    if(options.length){
      const clear=document.createElement('a');
      clear.href=clearURL();
      clear.className='pnm-clear-filters';clear.textContent=labels.clear;
      chips.append(clear);
    }
  }
  const start=()=>{
    sync();
    document.addEventListener('click',event=>{
      if(!event.target.closest('.globo-selected-items-wrapper .gf-refine-toggle'))return;
      event.preventDefault();event.stopImmediatePropagation();
      location.assign(clearURL());
    },true);
    const root=document.querySelector('.page-collections')||document.getElementById('MainContent');
    if(!root)return;
    new MutationObserver(records=>{
      if(records.some(record=>{
        if(record.type==='attributes')return record.attributeName==='aria-checked';
        return [...record.addedNodes].some(node=>node.nodeType===1&&(node.matches('#gf-controls-container,#gf-tree,[data-filter-id],.gf-actions,.pnm-catalog-models')||node.querySelector('#gf-controls-container,#gf-tree,[data-filter-id],.gf-actions')));
      }))schedule();
    }).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['aria-checked']});
  };
  window.addEventListener('pnm:bike-change',schedule);
  window.addEventListener('pnm:part-type-ready',schedule);
  window.addEventListener('globoFilterRenderCompleted',schedule);
  window.addEventListener('popstate',schedule);
  window.addEventListener('pageshow',schedule);
  document.addEventListener('shopify:section:load',schedule);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-collection-year"] && !Shopify.designMode) return;
  try {
    (()=>{
  const template=document.getElementById('pnm-collection-year-template');
  if(!template)return;
  let scheduled=false,anchorRestored=false,appliedKey='',pending={key:'',year:''};
  const schedule=()=>{if(!scheduled){scheduled=true;requestAnimationFrame(sync)}};
  const sync=()=>{
    scheduled=false;
    const api=window.PNMCollectionYear;
    const context=api?.context();
    const bike=context?.bike;
    const tree=document.getElementById('gf-tree');
    const category=tree?.querySelector('[data-filter-id="852978"]')||tree?.querySelector('[data-filter-id]');
    let panel=document.getElementById('pnm-collection-year');
    if(!context||!category){panel?.remove();return}
    const selectionKey=context.base+'|'+(bike?.key||'')+'|'+(bike?.bikeYear||'');
    if(appliedKey!==selectionKey){
      appliedKey=selectionKey;
      pending={key:bike?.key||'',year:bike?(bike.bikeYear||'*'):''};
    }
    if(!panel){
      panel=template.content.firstElementChild.cloneNode(true);
      panel.querySelector('.pnm-collection-year__heading').addEventListener('click',event=>{
        if(!window.PNMCollectionYear?.context()?.bike?.bikeYear||typeof window.PNMBikeSelector?.open!=='function')return;
        event.preventDefault();
        panel.querySelector('.pnm-year-editor').open=false;
        window.PNMBikeSelector.open(event.currentTarget);
      });
      panel.querySelector('#pnm-collection-model-select').addEventListener('change',event=>{
        pending={key:event.currentTarget.value,year:''};
        sync();
      });
      panel.querySelector('#pnm-collection-year-select').addEventListener('change',event=>{
        pending.year=event.currentTarget.value;
        sync();
      });
      panel.querySelector('form').addEventListener('submit',event=>{
        event.preventDefault();
        if(panel.hasAttribute('aria-busy'))return;
        const record=window.PNMCollectionYear?.context()?.models.find(model=>model.key===pending.key);
        if(!record||!(pending.year==='*'||record.years.includes(pending.year)))return;
        panel.setAttribute('aria-busy','true');
        panel.querySelectorAll('select,button').forEach(control=>control.disabled=true);
        const hint=panel.querySelector('.pnm-collection-year__hint');
        hint.hidden=false;
        hint.textContent=hint.dataset.loading;
        if(!window.PNMCollectionYear?.selectModelYear(pending.key,pending.year==='*'?'':pending.year)){
          panel.removeAttribute('aria-busy');
          sync();
          hint.hidden=false;
          hint.textContent=hint.dataset.error;
        }
      });
    }
    if(category.previousElementSibling!==panel)category.before(panel);
    const signature=context.base+'|'+context.models.map(model=>model.key+':'+model.years.join(',')).join(';');
    const modelSelect=panel.querySelector('#pnm-collection-model-select');
    const yearSelect=panel.querySelector('#pnm-collection-year-select');
    const apply=panel.querySelector('.pnm-collection-year__apply');
    if(panel.dataset.models!==signature){
      const placeholder=template.content.querySelector('#pnm-collection-model-select option').cloneNode(true);
      placeholder.disabled=true;
      const orderedModels=[...context.models];
      if(orderedModels.length&&orderedModels.every(model=>model.brand==='Honda'&&/^CB750(?:A|C|F|K|L|P|SC)$/.test(model.modelType))){
        const order=['CB750K','CB750F','CB750A','CB750C','CB750L','CB750P','CB750SC'];
        orderedModels.sort((a,b)=>order.indexOf(a.modelType)-order.indexOf(b.modelType));
      }
      modelSelect.replaceChildren(placeholder,...orderedModels.map(model=>new Option(model.modelDisplay||model.modelType,model.key)));
      panel.querySelector('[data-pnm-year-model]').textContent=context.label;
      panel.dataset.models=signature;
    }
    const model=context.models.find(record=>record.key===pending.key);
    if(!model)pending={key:'',year:''};
    if(model&&pending.year!=='*'&&!model.years.includes(pending.year))pending.year='';
    const yearSignature=(model?.key||'')+'|'+(model?.years||[]).join(',');
    if(panel.dataset.model!==yearSignature){
      const chooseYear=template.content.querySelector('#pnm-collection-year-select option[value=""]').cloneNode(true);
      const allYears=template.content.querySelector('#pnm-collection-year-select option[value="*"]').cloneNode(true);
      yearSelect.replaceChildren(chooseYear,...(model?.years||[]).map(year=>new Option(year,year)),allYears);
      panel.dataset.model=yearSignature;
    }
    const ready=Boolean(model&&(pending.year==='*'||model.years.includes(pending.year)));
    const dirty=pending.key!==(bike?.key||'')||pending.year!==(bike?(bike.bikeYear||'*'):'');
    if(!panel.hasAttribute('aria-busy')){
      modelSelect.value=pending.key;
      yearSelect.value=pending.year;
      modelSelect.disabled=false;
      yearSelect.disabled=!model;
      apply.disabled=!ready;
      const hint=panel.querySelector('.pnm-collection-year__hint');
      const message=!model?hint.dataset.chooseModel:!ready?hint.dataset.chooseYear:hint.dataset.ready;
      if(hint.textContent!==message)hint.textContent=message;
    }
    panel.dataset.selected=String(Boolean(bike?.bikeYear)&&!dirty);
    const editor=panel.querySelector('.pnm-year-editor');
    if(editor.dataset.selection!==selectionKey){
      editor.dataset.selection=selectionKey;
      editor.open=!bike?.bikeYear;
    }
    const heading=panel.querySelector('.pnm-collection-year__heading');
    if(bike?.bikeYear){
      heading.setAttribute('aria-haspopup','dialog');
      heading.setAttribute('aria-controls','pnm-model-dialog');
      heading.setAttribute('aria-expanded',String(Boolean(document.getElementById('pnm-model-dialog')?.open)));
    }else{
      heading.removeAttribute('aria-haspopup');
      heading.removeAttribute('aria-controls');
      heading.removeAttribute('aria-expanded');
    }
    const summary=panel.querySelector('[data-pnm-year-summary]');
    const selectedLabel=bike?.bikeYear?[bike.bikeYear,bike.brand,bike.modelDisplay||bike.modelType].join(' '):template.content.querySelector('[data-pnm-year-summary]').textContent;
    if(summary.textContent!==selectedLabel)summary.textContent=selectedLabel;
    const hint=panel.querySelector('.pnm-collection-year__hint');
    hint.hidden=Boolean(bike?.bikeYear)&&!dirty&&!panel.hasAttribute('aria-busy');
    if(!anchorRestored&&location.hash==='#pnm-collection-year'){
      anchorRestored=true;
      requestAnimationFrame(()=>panel.scrollIntoView({block:'start',behavior:'instant'}));
    }
  };
  const start=()=>{
    sync();
    new MutationObserver(changes=>{
      if(changes.some(change=>Array.from(change.addedNodes).some(node=>node.nodeType===1&&(node.matches('#gf-tree,[data-filter-id]')||node.querySelector('#gf-tree,[data-filter-id]')))))schedule();
    }).observe(document.body,{childList:true,subtree:true});
  };
  window.addEventListener('pnm:bike-change',schedule);
  window.addEventListener('globoFilterRenderCompleted',schedule);
  window.addEventListener('popstate',schedule);
  window.addEventListener('pageshow',()=>{
    appliedKey='';
    const panel=document.getElementById('pnm-collection-year');
    if(panel)panel.removeAttribute('aria-busy');
    schedule();
  });
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-header-localization"] && !Shopify.designMode) return;
  try {
    (() => {
  const host = document.querySelector('[data-pnm-header-localization]');
  if (!host) return;
  let native = null;
  let frame = 0;
  let applying = false;
  const groups = '.ht-tms-single-dropdown__container';
  const selected = '.ht-tms-dropdown__selected';
  const options = '.ht-tms-option__item';
  function place() {
    const bar = document.querySelector('[data-pnm-bike-bar]:not([hidden])');
    const small = window.matchMedia('(max-width:700px)').matches;
    const mobileHeader = window.matchMedia('(max-width:1024px)').matches;
    const target = bar ? bar.querySelector(small ? '.pnm-bike-bar__inner' : '.pnm-bike-bar__actions') : document.querySelector(mobileHeader ? '.halo-header-mobile' : '.header-top .container');
    if (!target) return false;
    if (host.parentElement !== target) target.appendChild(host);
    host.classList.toggle('pnm-header-localization--home', !bar);
    return true;
  }
  function enhance() {
    if (!native?.isConnected) return;
    const code = window.tms?.selectorApi?.currency?.code || host.dataset.currency;
    native.querySelectorAll(groups).forEach(group => {
      const trigger = group.querySelector(selected);
      const list = group.querySelector('.ht-tms-single-dropdown__dropdown-wrapper');
      if (!trigger || !list) return;
      const isLanguage = group.classList.contains('ht-tms-single-dropdown__container--language');
      if (!isLanguage && code) {
        let text = trigger.querySelector('.pnm-currency-code');
        if (!text) { text = document.createElement('span'); text.className = 'pnm-currency-code'; trigger.appendChild(text); }
        if (text.textContent !== code) text.textContent = code;
      }
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', String(group.classList.contains('ht-tms-single-dropdown__container--open')));
      list.setAttribute('role', 'listbox');
      group.querySelectorAll(options).forEach(option => {
        option.setAttribute('role', 'option');
        option.setAttribute('tabindex', '-1');
      });
    });
  }
  function init() {
    frame = 0;
    if (!native?.isConnected) {
      native = document.querySelector('.ht-tms__duo-selector:has(.ht-tms-single-dropdown__container--language):has(.ht-tms__duo-selector__button)');
      if (!native || !place()) return;
      host.appendChild(native);
      host.hidden = false;
    }
    place();
    enhance();
  }
  function schedule() { if (!frame) frame = requestAnimationFrame(init); }
  host.addEventListener('click', event => {
    const option = event.target.closest(options);
    if (option && !applying) {
      applying = true;
      setTimeout(() => {
        native.querySelector('.ht-tms__duo-selector__button')?.click();
        applying = false;
        schedule();
      }, 0);
    }
    schedule();
  }, true);
  host.addEventListener('keydown', event => {
    const group = event.target.closest(groups);
    if (!group) return;
    const trigger = group.querySelector(selected);
    const items = [...group.querySelectorAll(options)];
    const current = items.indexOf(event.target.closest(options));
    if (event.key === 'Escape') {
      event.preventDefault();
      group.classList.remove('ht-tms-single-dropdown__container--open');
      trigger.focus();
    } else if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
      event.preventDefault();
      if (!group.classList.contains('ht-tms-single-dropdown__container--open')) trigger.click();
      const index = current < 0 ? (event.key === 'ArrowDown' ? 0 : items.length - 1) : (current + (event.key === 'ArrowDown' ? 1 : -1) + items.length) % items.length;
      items[index]?.focus();
    } else if ((event.key === 'Enter' || event.key === ' ') && current >= 0) {
      event.preventDefault();
      items[current].click();
    }
    schedule();
  });
  document.addEventListener('click', event => {
    if (!host.contains(event.target)) host.querySelectorAll('.ht-tms-single-dropdown__container--open').forEach(group => group.classList.remove('ht-tms-single-dropdown__container--open'));
  });
  const observer = new MutationObserver(schedule);
  observer.observe(document.body, { childList:true, subtree:true });
  window.addEventListener('resize', schedule, { passive:true });
  window.addEventListener('pageshow', schedule);
  document.addEventListener('shopify:section:load', schedule);
  init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-honda-model-directory"] && !Shopify.designMode) return;
  try {
    (() => {
  const normalize = value => String(value || '').toLowerCase()
    .replace(/[^a-z0-9]+/g, ' ')
    .replace(/\b(honda|yamaha|kawasaki|suzuki|parts|motorcycle|motorcycles)\b/g, ' ')
    .replace(/\bgold\s+wing\b/g, 'goldwing')
    .replace(/\b([a-z]+)\s+(?=\d)/g, '$1')
    .replace(/(\d)\s+([a-z]{1,2})\b/g, '$1$2')
    .trim().replace(/\s+/g, ' ');
  const matchScore = (label, query) => {
    if (!query) return 0;
    if (label === query) return 0;
    const words = label.split(' ');
    if (words.includes(query)) return 1;
    if (label.startsWith(query)) return 2;
    return query.split(' ').every(token => words.some(word => word.startsWith(token))) ? 3 : Infinity;
  };
  const initialize = scope => {
    scope.querySelectorAll('[data-honda-directory]').forEach(root => {
      if (root.dataset.ready) return;
      root.dataset.ready = 'true';
      const search = root.querySelector('input');
      const form = root.querySelector('[data-directory-search]');
      const clear = root.querySelector('[data-directory-clear]');
      const browse = root.querySelector('[data-directory-browse]');
      const browseLabel = root.querySelector('[data-directory-browse-label]');
      const status = root.querySelector('[data-directory-status]');
      const empty = root.querySelector('[data-directory-empty]');
      const list = root.querySelector('.pnm-honda-directory__list');
      const links = [...root.querySelectorAll('[data-directory-link]')].map(element => ({ element, term: normalize(element.dataset.search), family: normalize(element.dataset.familySearch || '') }));
      const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
      links.sort((a, b) => collator.compare(a.term, b.term));
      links.forEach(link => list.append(link.element));
      let wasOpen = false;
      let searching = false;
      const filter = () => {
        const term = normalize(search.value);
        if (term && !searching) wasOpen = browse.open;
        let count = 0;
        links.forEach(link => {
          const directScore = matchScore(link.term, term);
          const familyScore = matchScore(link.family, term);
          link.score = Math.min(directScore, Number.isFinite(familyScore) ? familyScore + 4 : Infinity);
          const match = Number.isFinite(link.score);
          link.element.hidden = !match;
          if (match) count += 1;
        });
        links.sort((a, b) => (a.score - b.score || collator.compare(a.term, b.term)));
        links.forEach(link => list.append(link.element));
        clear.hidden = !search.value;
        empty.hidden = !term || count > 0;
        list.hidden = Boolean(term) && count === 0;
        status.textContent = term ? (count === 1 ? root.dataset.resultOne : root.dataset.resultMany.replace('999999', String(count))) : '';
        browseLabel.textContent = term ? browseLabel.dataset.searchLabel : browseLabel.dataset.default;
        if (term) browse.open = true;
        else if (searching) browse.open = wasOpen;
        searching = Boolean(term);
      };
      search.addEventListener('input', filter);
      search.addEventListener('search', filter);
      search.addEventListener('keydown', event => {
        if (event.key === 'Escape' && search.value) {
          event.preventDefault();
          search.value = '';
          filter();
        }
      });
      clear.addEventListener('click', () => {
        search.value = '';
        filter();
        search.focus();
      });
      form.addEventListener('submit', event => {
        event.preventDefault();
        filter();
        browse.open = true;
        links.find(link => !link.element.hidden)?.element.querySelector('a').focus();
      });
      root.querySelector('[data-directory-controls]').hidden = false;
      const picker = root.querySelector('[data-pnm-bike-open]');
      picker.hidden = !document.querySelector('[data-pnm-bike-bar][data-model-types-ready="true"]');
      filter();
    });
  };
  const start = () => initialize(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
  document.addEventListener('shopify:section:load', start);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-main-category-links"] && !Shopify.designMode) return;
  try {
    (() => {
  const nav = document.querySelector('[data-pnm-main-categories]');
  if (!nav) return;
  const links = [...nav.querySelectorAll('a[data-category]')];
  const allPartsLink = nav.querySelector('[data-pnm-browse-all]');
  const allPartsLabel = nav.querySelector('[data-pnm-all-label]');
  const allPartsCheck = nav.querySelector('[data-pnm-all-check]');
  const allPartsBike = nav.querySelector('[data-pnm-all-bike]');
  const allPartsBikeText = nav.querySelector('[data-pnm-all-bike-text]');
  let allPartsFitFrame = 0, allPartsFitKey = '';
  function fitAllBikeName() {
    allPartsFitFrame = 0;
    if (!allPartsBikeText || allPartsBike.hidden) return;
    const available = allPartsBike.clientWidth;
    if (!available) return;
    const key = available + '|' + allPartsBikeText.textContent;
    if (key === allPartsFitKey) return;
    allPartsFitKey = key;
    allPartsBikeText.style.fontSize = '16px';
    const natural = allPartsBikeText.getBoundingClientRect().width;
    if (natural > available) allPartsBikeText.style.fontSize = (Math.floor(16 * (available - 1) / natural * 100) / 100) + 'px';
  }
  function scheduleAllBikeFit() {
    if (!allPartsFitFrame) allPartsFitFrame = requestAnimationFrame(fitAllBikeName);
  }
  if (window.ResizeObserver && allPartsBike) new ResizeObserver(scheduleAllBikeFit).observe(allPartsBike);
  window.addEventListener('resize',scheduleAllBikeFit,{passive:true});
  document.fonts?.ready.then(() => { allPartsFitKey = ''; scheduleAllBikeFit(); });
  const categorySelect = nav.querySelector('[data-pnm-category-select]');
  const categoryOptions = new Map([...categorySelect.options].map(option => [option.value,option]));
  const mobileBrowser = nav.querySelector('[data-pnm-mobile-browser]');
  const mobileBrowse = nav.querySelector('[data-pnm-mobile-browse]');
  function syncMobileCategory() {
    if (!mobileBrowser) return;
    const selected = links.find(link => link.getAttribute('aria-current') === 'page');
    const label = selected?.dataset.category || nav.dataset.allLabel;
    const current = nav.querySelector('[data-pnm-mobile-current]');
    if (current.textContent !== label) current.textContent = label;
    const value = selected?.dataset.pnmMobileCount;
    const count = value === undefined || value === '' ? null : Number(value);
    const badge = nav.querySelector('[data-pnm-mobile-count]');
    badge.hidden = count === null;
    const text = count === null ? '' : count === 1 ? mobileBrowser.dataset.countOne : mobileBrowser.dataset.countMany.replace('[count]',count);
    if (badge.textContent !== text) badge.textContent = text;
  }
  mobileBrowse?.addEventListener('click',() => {
    const open = mobileBrowse.getAttribute('aria-expanded') !== 'true';
    mobileBrowse.setAttribute('aria-expanded',String(open));
    nav.dataset.mobileOpen = String(open);
    if (open) scheduleAllBikeFit();
  });
  nav.addEventListener('keydown',event => {
    if (event.key !== 'Escape' || nav.dataset.mobileOpen !== 'true') return;
    nav.dataset.mobileOpen = 'false';
    mobileBrowse.setAttribute('aria-expanded','false');
    mobileBrowse.focus({preventScroll:true});
  });
  const categoryValue = label => label === 'Tach & Speedo' ? 'Tachometer & Speedometer' : label;
  const categoryLabel = value => value === 'Tachometer & Speedometer' ? 'Tach & Speedo' : value;
  const bikeKeys = ['gff_705339', 'gff_705340', 'gff_705341', 'gff_705342'];
  const base = path => path.match(/.*?\/collections\/[^/]+/)?.[0] || '';
  const handle = text => text.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '');
  links.forEach(link => {
    if (link.dataset.category === 'Tach & Speedo') link.dataset.categoryTag = handle(categoryValue(link.dataset.category));
  });
  const universal = url => url.pathname.slice(base(url.pathname).length + 1).split('+').includes('universal');
  const relative = url => url.pathname + url.search + url.hash;
  let redirecting = false;
  function context() {
    const current = new URL(location.href);
    const isCategory = nav.dataset.categoryPage === 'true';
    if (universal(current)) return {isCategory, universal:true, bike:null, scoped:false};
    const api = window.PNMCollectionYear;
    const own = api?.context();
    const isModel = Boolean(own?.bike && [own.bike.target, own.bike.baseURL].includes(own.base));
    let bike = isModel ? own.bike : null;
    // Saved bikes may scope parts categories, but must not override a bike collection.
    if (!bike && api && isCategory) {
      const saved = document.querySelector('[data-pnm-bike-parts]:not([hidden])');
      if (saved?.getAttribute('href')) {
        const source = new URL(saved.getAttribute('href'), location.origin);
        const explicit = bikeKeys.some(key => current.searchParams.has(key));
        const params = explicit ? current.searchParams : source.searchParams;
        const candidate = api.context(source.pathname, params)?.bike;
        if (candidate && (!explicit || (params.get('gff_705339')?.split(',').every(value => value.trim().replace(/ - ATV$/,'') === candidate.brand.replace(/ - ATV$/,'')) && candidate.modelType === params.get('gff_705341') && (!params.has('gff_705342') || candidate.bikeYear === params.get('gff_705342'))))) bike = candidate;
      }
    }
    const tag = bike ? handle(bike.modelType + (bike.bikeYear && bike.modelType !== 'VTX1300S' ? ' (' + bike.bikeYear + ')' : '')) : '';
    const tags = current.pathname.slice(base(current.pathname).length + 1).split('+');
    const category = nav.dataset.activeCategory;
    const scoped = Boolean(bike && (isModel || (isCategory && tags.includes(tag) && tags.includes(handle(categoryValue(category))))));
    return {bike, isModel, isCategory, tag, scoped, universal:false};
  }
  function destination(anchor, state = context(), keepFilters = false) {
    const current = new URL(location.href);
    const target = new URL(anchor.dataset.pnmCategoryBase || anchor.getAttribute('href'), location.origin);
    if (target.origin !== location.origin) return null;
    if (!state.isCategory) {
      const scoped = new URL(location.href);
      const oldPartType = scoped.searchParams.get('pnm_part_type');
      {
        const scopeBase = base(scoped.pathname);
        const tags = scoped.pathname.slice(scopeBase.length + 1).split('+').filter(tag => tag && tag !== oldPartType && !links.some(link => link.dataset.categoryTag === tag));
        scoped.pathname = scopeBase + (tags.length ? '/' + tags.join('+') : '');
      }
      [...scoped.searchParams.keys()].filter(key => /^gf_/.test(key)).forEach(key => scoped.searchParams.delete(key));
      ['pnm_part_type','page'].forEach(key => scoped.searchParams.delete(key));
      scoped.searchParams.set('gf_852978',categoryValue(anchor.dataset.category));
      scoped.hash = window.matchMedia('(min-width:768px)').matches ? 'CollectionProductGrid' : 'pnm-main-categories';
      return scoped;
    }
    target.pathname = base(target.pathname);
    target.search = keepFilters ? current.search : '';
    target.hash = window.matchMedia('(min-width:768px)').matches ? 'CollectionProductGrid' : 'pnm-main-categories';
    ['preview_theme_id','sort_by'].forEach(key => {
      if (current.searchParams.has(key)) target.searchParams.set(key, current.searchParams.get(key));
    });
    target.searchParams.delete('page');
    target.searchParams.delete('gf_page');
    target.searchParams.delete('gf_852978');
    bikeKeys.forEach(key => target.searchParams.delete(key));
    if (state.universal) target.pathname += '/universal';
    else if (state.bike) {
      target.pathname += '/' + state.tag + '+' + anchor.dataset.categoryTag;
      Object.entries(state.bike.filters).forEach(([key,value]) => target.searchParams.set(key,value));
    }
    return target;
  }
  function normalize(state) {
    if (redirecting || !state.bike || state.universal || !state.isCategory) return;
    const current = new URL(location.href);
    const selected = current.searchParams.getAll('gf_852978');
    const label = state.isCategory ? nav.dataset.activeCategory : selected.length === 1 ? categoryLabel(selected[0]) : '';
    const anchor = links.find(link => link.dataset.category === label);
    if (!anchor || (!state.isCategory && !state.isModel)) return;
    if (state.isCategory && state.scoped) return;
    const target = destination(anchor,state,true);
    if (!target) return;
    if (state.isCategory) target.pathname = base(current.pathname) + '/' + state.tag + '+' + anchor.dataset.categoryTag;
    if (relative(target) === relative(current)) return;
    redirecting = true;
    location.replace(target.href);
  }

  let countsKey = '', countsValue = null, countRequest = null, countRetryAt = 0;
  const countMemory = new Map();
  const countStorage = 'pnm_bike_category_counts_v3';
  function countURL(state) {
    const embed = window.GloboEmbedFilterConfig;
    if (!embed?.api?.url || !embed?.shop?.domain) return null;
    const url = new URL('/api/apiFilter',embed.api.url);
    if (url.protocol !== 'https:') return null;
    url.searchParams.set('shop',embed.shop.domain);
    url.searchParams.set('filter_id','54585');
    const current = new URL(location.href);
    if (state.bike && !state.universal) url.searchParams.set('currentTags[]',state.bike.modelType + (state.bike.bikeYear && state.bike.modelType !== 'VTX1300S' ? ' (' + state.bike.bikeYear + ')' : ''));
    else if (!state.isCategory) {
      if (embed.collection?.id) url.searchParams.set('collection',String(embed.collection.id));
      const oldPartType = current.searchParams.get('pnm_part_type');
      (embed.collection?.tags || []).filter(tag => handle(tag) !== oldPartType && !links.some(link => link.dataset.categoryTag === handle(tag))).forEach(tag => url.searchParams.append('currentTags[]',tag));
    }
    if (state.universal) url.searchParams.set('currentTags[]','Universal');
    const bikeFilters = state.bike?.filters || Object.fromEntries([...current.searchParams].filter(([key]) => /^gff_/.test(key)));
    const fitmentParams = window.pnmFitmentParams?.(bikeFilters) || bikeFilters;
    Object.entries(fitmentParams).forEach(([key,value]) => {
      if (/^gff_\d+$/.test(key) && value) {
        (Array.isArray(value) ? value : [value]).forEach(item => url.searchParams.append('form[' + key.slice(4) + '][]',item));
      }
    });
    url.searchParams.set('page','1');
    url.searchParams.set('limit','1');
    url.searchParams.set('event','init');
    url.searchParams.set('page_type','collection');
    const country = window.currentCountry || window.Shopify?.country;
    if (country) url.searchParams.set('country',country);
    if (window.currentCurrency) url.searchParams.set('currency',window.currentCurrency);
    if (window.currentLanguageCode) url.searchParams.set('locale',window.currentLanguageCode);
    return url;
  }
  function parseCounts(data) {
    const total = Number(data?.pagination?.total);
    if (data?.pagination?.total == null || !Number.isInteger(total) || total < 0 || !Array.isArray(data.filters)) return null;
    const facet = data.filters.find(filter => String(filter.id) === '852978');
    if (!facet && total !== 0) return null;
    if (facet && !Array.isArray(facet.values)) return null;
    const values = {};
    for (const option of facet?.values || []) {
      const count = Number(option.count);
      if (typeof option.value !== 'string' || option.count == null || !Number.isInteger(count) || count < 0) return null;
      values[option.value] = count;
    }
    return Object.fromEntries(links.map(link => [link.dataset.category, values[categoryValue(link.dataset.category)] || 0]));
  }
  function paintCounts(value) {
    nav.dataset.countsState = value ? 'ready' : 'unknown';
    const selectedValue = categorySelect.value;
    const visibleOptions = [categoryOptions.get('')];
    const orderedLinks = value ? [...links].sort((first, second) => (value[second.dataset.category] ?? -1) - (value[first.dataset.category] ?? -1)) : links;
    const categoryList = nav.querySelector('.pnm-main-categories__list');
    const focused = document.activeElement;
    orderedLinks.forEach((link, index) => {
      const item = link.closest('li');
      if (categoryList.children[index] !== item) categoryList.insertBefore(item, categoryList.children[index] || null);
      const category = link.dataset.category;
      const count = value?.[category];
      const known = Number.isInteger(count) && count >= 0;
      link.dataset.pnmMobileCount = known ? String(count) : '';
      const empty = known && count === 0;
      const current = link.getAttribute('aria-current') === 'page';
      const hide = empty;
      link.dataset.empty = String(empty);
      link.setAttribute('aria-controls','pnm-category-details');
      link.closest('li').hidden = hide;
      const badge = link.querySelector('[data-pnm-category-count]');
      badge.hidden = !known;
      const text = !known ? '' : empty ? nav.dataset.noMatches : count === 1 ? nav.dataset.matchingOne : nav.dataset.matchingMany.replace('[count]',count);
      if (badge.textContent !== (known ? String(count) : '')) badge.textContent = known ? String(count) : '';
      if (known) badge.setAttribute('aria-label',text);
      link.removeAttribute('aria-disabled');
      link.removeAttribute('tabindex');
      link.removeAttribute('title');
      if (!empty) { link.removeAttribute('aria-expanded'); link.removeAttribute('aria-controls'); }
      else if (!link.hasAttribute('aria-expanded')) link.setAttribute('aria-expanded','false');
      const option = categoryOptions.get(category);
      if (option) {
        const label = category + (known ? ' (' + count + ')' : '');
        if (option.textContent !== label) option.textContent = label;
        option.disabled = false;
        if (hide) option.remove();
        else visibleOptions.push(option);
      }
    });
    visibleOptions.forEach((option,index) => {
      if (categorySelect.options[index] !== option) categorySelect.insertBefore(option,categorySelect.options[index] || null);
    });
    categorySelect.value = visibleOptions.some(option => option.value === selectedValue) ? selectedValue : '';
    if (nav.contains(focused) && document.activeElement !== focused) focused.focus({preventScroll:true});
    syncMobileCategory();
  }
  function syncCounts(state) {
    const url = countURL(state);
    const key = url?.href || '';
    if (key !== countsKey) {
      countRequest?.abort();
      countRequest = null;
      countsKey = key;
      countsValue = null;
      countRetryAt = 0;
      paintCounts(null);
    }
    if (!key) return;
    let cached = countMemory.get(key);
    if (!cached) {
      try { cached = JSON.parse(sessionStorage.getItem(countStorage) || '[]').find(entry => entry.key === key); } catch (_) {}
    }
    if (cached && Date.now() - cached.time < 120000 && cached.value && links.every(link => Number.isInteger(cached.value[link.dataset.category]) && cached.value[link.dataset.category] >= 0)) {
      countsValue = cached.value;
      paintCounts(countsValue);
      return;
    }
    if (countRequest || Date.now() < countRetryAt) return;
    const controller = new AbortController();
    countRequest = controller;
    const timeout = setTimeout(() => controller.abort(),10000);
    fetch(key,{credentials:'omit',signal:controller.signal})
      .then(response => { if (!response.ok) throw new Error('Counts unavailable'); return response.json(); })
      .then(async data => {
        const value = parseCounts(data);
        if (!value) throw new Error('Invalid counts');
        const tach = links.find(link => link.dataset.category === 'Tach & Speedo');
        const facet = data.filters.find(filter => String(filter.id) === '852978');
        if (tach && !facet?.values?.some(option => option.value === categoryValue(tach.dataset.category))) {
          const tachURL = new URL(key);
          tachURL.searchParams.set('form[852978][]',categoryValue(tach.dataset.category));
          const response = await fetch(tachURL.href,{credentials:'omit',signal:controller.signal});
          if (!response.ok) throw new Error('Category count unavailable');
          const result = await response.json();
          const total = Number(result?.pagination?.total);
          if (result?.pagination?.total == null || !Number.isInteger(total) || total < 0) throw new Error('Invalid category count');
          value[tach.dataset.category] = total;
        }
        if (countsKey !== key || controller.signal.aborted) return;
        const entry = {key,time:Date.now(),value};
        countMemory.set(key,entry);
        if (countMemory.size > 8) countMemory.delete(countMemory.keys().next().value);
        try {
          const saved = JSON.parse(sessionStorage.getItem(countStorage) || '[]');
          const entries = Array.isArray(saved) ? saved.filter(item => item.key !== key && Date.now() - item.time < 120000).slice(-7) : [];
          sessionStorage.setItem(countStorage,JSON.stringify([...entries,entry]));
        } catch (_) {}
        countsValue = value;
        paintCounts(value);
      })
      .catch(() => {
        if (countsKey !== key || countRequest !== controller) return;
        countsValue = null;
        paintCounts(null);
        countRetryAt = Date.now() + 30000;
      })
      .finally(() => { clearTimeout(timeout); if (countRequest === controller) countRequest = null; });
  }
  function labelPartTypes(state) {
    if (!state.isCategory) return;
    const label = nav.dataset.partTypes.replace('[category]',nav.dataset.activeCategory);
    document.querySelectorAll('#gf-tree .gf-block-title .h3').forEach(heading => {
      const walker = document.createTreeWalker(heading,NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (/\bcategories\s*$/i.test(node.nodeValue.trim())) {
          node.nodeValue = label;
          if (heading.hasAttribute('aria-label')) heading.setAttribute('aria-label',label);
          break;
        }
      }
    });
  }

  function hasResultRefinements(state) {
    const current = new URL(location.href);
    const hasFilter = [...current.searchParams].some(([key,value]) => {
      if (!value.trim()) return false;
      return key === 'q' || key === 'pnm_part_type' || /^filter\./.test(key) ||
        (/^gf_/.test(key) && !['gf_page','gf_sort_by','gf_limit'].includes(key)) ||
        (/^gff_/.test(key) && !bikeKeys.includes(key));
    });
    if (hasFilter) return true;
    if (!state.bike) return false;
    const target = new URL(state.bike.partsURL,location.origin);
    const scopeTags = new Set(target.pathname.slice(base(target.pathname).length + 1).split('+').filter(Boolean));
    if (state.tag) scopeTags.add(state.tag);
    return current.pathname.slice(base(current.pathname).length + 1).split('+').some(tag => tag && !scopeTags.has(tag));
  }

  function sync() {
    const state = context();
    if (detailsKey && detailsKey !== (state.bike?.key || '') + '|' + location.pathname) closeEmptyCategory(false);
    nav.hidden = false;
    document.body.classList.toggle('pnm-model-category-browse', Boolean(state.isModel && !nav.hidden));
    document.body.classList.toggle('pnm-category-browse', state.isCategory);
    if (nav.hidden) return;
    normalize(state);
    const heading = nav.querySelector('[data-pnm-category-heading]');
    const bikeText = state.bike ? [state.bike.bikeYear,state.bike.brand,state.bike.modelDisplay || state.bike.modelType].filter(Boolean).join(' ') : '';
    const headingText = nav.dataset.defaultHeading;
    const bikeLine = nav.querySelector('[data-pnm-category-bike]');
    bikeLine.hidden = !bikeText;
    const bikeLineText = bikeText ? nav.dataset.selectedBike.replace('[bike]',bikeText) : '';
    if (bikeLine.textContent !== bikeLineText) bikeLine.textContent = bikeLineText;
    if (heading.textContent !== headingText) heading.textContent = headingText;
    const mobileHeading = nav.querySelector('[data-pnm-mobile-heading]');
    const mobileHeadingText = bikeText ? nav.dataset.bikeHeading.replace('[bike]',bikeText) : headingText;
    if (mobileHeading && mobileHeading.textContent !== mobileHeadingText) mobileHeading.textContent = mobileHeadingText;
    nav.dataset.hasBike = String(Boolean(state.bike));
    const currentTags = location.pathname.slice(base(location.pathname).length + 1).split('+');
    const taggedCategory = links.find(link => currentTags.includes(link.dataset.categoryTag))?.dataset.category || '';
    const selected = state.isCategory ? nav.dataset.activeCategory : categoryLabel(new URLSearchParams(location.search).get('gf_852978')) || taggedCategory;
    links.forEach(link => {
      if (!link.dataset.pnmCategoryBase) link.dataset.pnmCategoryBase = link.getAttribute('href');
      if (link.dataset.category === selected) link.setAttribute('aria-current','page');
      else link.removeAttribute('aria-current');
    });
    syncCounts(state);
    links.forEach(link => {
      const target = destination(link,state);
      if (target) link.href = relative(target);
    });
    labelPartTypes(state);
    const all = allPartsLink;
    all.hidden = false;
    const allCurrent = !selected && !hasResultRefinements(state) && (!state.bike || (state.isModel && state.scoped));
    const viewingBike = Boolean(state.bike && allCurrent);
    const allLabel = viewingBike ? nav.dataset.bikeViewingLabel : state.bike ? nav.dataset.bikeAllLabel : nav.dataset.viewAllLabel;
    allPartsCheck.toggleAttribute('hidden', !viewingBike);
    if (allPartsLabel.textContent !== allLabel) allPartsLabel.textContent = allLabel;
    if (allPartsBikeText.textContent !== bikeText) allPartsBikeText.textContent = bikeText;
    allPartsBike.hidden = !bikeText;
    all.dataset.hasBike = String(Boolean(bikeText));
    const allAccessibleLabel = [allLabel,bikeText].filter(Boolean).join(' ');
    if (all.getAttribute('aria-label') !== allAccessibleLabel) all.setAttribute('aria-label',allAccessibleLabel);
    scheduleAllBikeFit();
    all.toggleAttribute('aria-current', allCurrent);
    if (all.hasAttribute('aria-current')) all.setAttribute('aria-current','page');
    if (state.bike) {
      const target = new URL(state.bike.partsURL,location.origin);
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) target.searchParams.set('preview_theme_id',preview);
      target.hash = window.matchMedia('(min-width:768px)').matches ? 'CollectionProductGrid' : 'pnm-main-categories';
      all.href = relative(target);
    }
    if (!state.bike) {
      const target = state.isCategory ? new URL('/collections/all',location.origin) : new URL(location.href);
      const oldPartType = target.searchParams.get('pnm_part_type');
      {
        const scopeBase = base(target.pathname);
        const tags = target.pathname.slice(scopeBase.length + 1).split('+').filter(tag => tag && tag !== oldPartType && !links.some(link => link.dataset.categoryTag === tag));
        target.pathname = scopeBase + (tags.length ? '/' + tags.join('+') : '');
      }
      [...target.searchParams.keys()].filter(key => /^gf_/.test(key)).forEach(key => target.searchParams.delete(key));
      ['pnm_part_type','page'].forEach(key => target.searchParams.delete(key));
      if (state.universal && state.isCategory) target.pathname += '/universal';
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) target.searchParams.set('preview_theme_id',preview);
      target.hash = window.matchMedia('(min-width:768px)').matches ? 'CollectionProductGrid' : 'pnm-main-categories';
      all.href = relative(target);
    }
    const select = nav.querySelector('[data-pnm-category-select]');
    select.value = selected;
    select.options[0].disabled = true;
    select.options[0].textContent = state.isModel ? nav.dataset.allLabel : select.options[0].textContent;
    nav.querySelector('.pnm-main-categories__mobile').hidden = false;
    nav.dataset.ready = 'true';
    syncMobileCategory();
    if (state.isCategory) {
      const filter = document.querySelector('#gf-controls-container .gf-refine-toggle-mobile button');
      if (filter && filter.dataset.pnmPartType !== 'true') {
        [...filter.childNodes].filter(node => node.nodeType === 3).forEach(node => node.remove());
        filter.append(document.createTextNode(' ' + nav.dataset.filterLabel));
        filter.setAttribute('aria-label',nav.dataset.filterLabel);
        filter.dataset.pnmPartType = 'true';
        filter.dataset.pnmCompactLabel = 'true';
      }
    }
    window.dispatchEvent(new CustomEvent('pnm:browse-ready'));
  }
  const details = nav.querySelector('[data-pnm-category-details]');
  let detailsAnchor = null, detailsKey = '', detailsTicket = 0;
  function closeEmptyCategory(focus = true) {
    detailsTicket++;
    details.hidden = true;
    detailsAnchor?.setAttribute('aria-expanded','false');
    if (focus && detailsAnchor) detailsAnchor.focus({preventScroll:true});
    detailsAnchor = null; detailsKey = '';
  }
  async function showEmptyCategory(anchor) {
    const state = context(), labels = window.PNMEasyShopping?.labels;
    if (!state.bike || !labels) { location.assign(anchor.href); return; }
    closeEmptyCategory(false);
    const ticket = ++detailsTicket;
    detailsAnchor = anchor;
    detailsKey = (state.bike.key || '') + '|' + location.pathname;
    const category = anchor.dataset.category;
    const bikeText = [state.bike.bikeYear,state.bike.brand,state.bike.modelDisplay || state.bike.modelType].filter(Boolean).join(' ');
    details.querySelector('h3').textContent = labels.empty_category.replace('[category]',category).replace('[bike]',bikeText);
    details.querySelector('[data-pnm-category-explanation]').textContent = labels.empty_note;
    const more = details.querySelector('[data-pnm-category-universal]');
    const note = details.querySelector('[data-pnm-category-universal-note]');
    more.hidden = true; note.hidden = true;
    details.querySelector('[data-pnm-category-help]').href = window.PNMEasyShopping.contactURL(category);
    details.hidden = false; anchor.setAttribute('aria-expanded','true');
    details.focus({preventScroll:true});
    details.scrollIntoView({block:'nearest',behavior:'instant'});
    const url = new URL(anchor.dataset.pnmCategoryBase,location.origin);
    url.pathname = base(url.pathname) + '/universal';
    url.search = ''; url.hash = '';
    const preview = new URLSearchParams(location.search).get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id',preview);
    const available = await window.PNMEasyShopping.universalAvailable(url);
    if (ticket !== detailsTicket || !available) return;
    more.href = relative(url); more.textContent = labels.universal_button.replace('[category]',category);
    more.hidden = false; note.hidden = false;
  }
  function prepare(event) {
    if (event.defaultPrevented || (event.type === 'auxclick' && event.button !== 1)) return;
    const anchor = event.target.closest('[data-pnm-main-categories] a[data-category]');
    if (!anchor) return;
    if (anchor.dataset.empty === 'true' && context().bike && event.type === 'click' && !event.ctrlKey && !event.metaKey && !event.shiftKey && !event.altKey && event.button === 0) { event.preventDefault(); showEmptyCategory(anchor); return; }
    const target = destination(anchor);
    if (!target) return;
    anchor.href = relative(target);

  }
  window.PNMBikeBrowse = {context, destination};
  nav.querySelector('[data-pnm-category-close]').addEventListener('click',closeEmptyCategory);
  document.addEventListener('click',prepare);
  document.addEventListener('auxclick',prepare);
  nav.querySelector('[data-pnm-category-select]').addEventListener('change',event => {
    const anchor = links.find(link => link.dataset.category === event.target.value);
    if (anchor?.getAttribute('aria-disabled') === 'true') return;
    const state = context();
    const target = anchor ? destination(anchor,state) : state.bike ? new URL(state.bike.partsURL,location.origin) : null;
    if (target) {
      const preview = new URLSearchParams(location.search).get('preview_theme_id');
      if (preview) target.searchParams.set('preview_theme_id',preview);
      location.assign(target.href);
    }
  });
  window.addEventListener('pnm:bike-change',sync);
  window.addEventListener('globoFilterRenderCompleted',sync);
  window.addEventListener('popstate',sync);
  window.addEventListener('pageshow',sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',sync,{once:true});
  else sync();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-menu-bike-panel"] && !Shopify.designMode) return;
  try {
    (() => {
  let cleanup;
  const initialize = () => {
    const dialog = document.getElementById('pnm-menu-bike-dialog');
    if (!dialog || dialog.dataset.ready) return;
    cleanup?.();
    const controller = new AbortController();
    cleanup = () => controller.abort();
    dialog.dataset.ready = 'true';
    const heading = dialog.querySelector('h2');
    const modelPanel = dialog.querySelector('[data-menu-bike-model-panel]');
    const yearPanel = dialog.querySelector('[data-menu-bike-year-panel]');
    const models = dialog.querySelector('[data-menu-bike-models]');
    const years = dialog.querySelector('[data-menu-bike-years]');
    const back = dialog.querySelector('[data-menu-bike-back]');
    const apply = dialog.querySelector('[data-menu-bike-apply]');
    const browse = dialog.querySelector('[data-menu-bike-browse]');
    const selection = dialog.querySelector('[data-menu-bike-selection]');
    const status = dialog.querySelector('[data-menu-bike-status]');
    const error = dialog.querySelector('[data-menu-bike-error]');
    let context, record, year = '', lastTrigger;
    const setStep = value => {
      dialog.querySelectorAll('[data-menu-bike-step]').forEach(step => {
        if (step.dataset.menuBikeStep === value) step.setAttribute('aria-current', 'step');
        else step.removeAttribute('aria-current');
      });
      modelPanel.hidden = value !== 'model';
      yearPanel.hidden = value !== 'year';
      error.hidden = true;
    };
    const modelButton = item => {
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'pnm-menu-bike__model';
      button.dataset.menuBikeModel = item.key;
      const label = document.createElement('span');
      label.textContent = item.modelDisplay;
      const arrow = document.createElement('span');
      arrow.textContent = '›';
      arrow.setAttribute('aria-hidden', 'true');
      button.append(label, arrow);
      return button;
    };
    const showModels = () => {
      setStep('model');
      heading.textContent = dialog.dataset.modelTitle.replace('__collection__', context.label);
      models.replaceChildren(...context.models.map(modelButton));
      const current = [...models.children].find(button => button.dataset.menuBikeModel === record?.key);
      (current || models.firstElementChild)?.focus();
      status.textContent = heading.textContent;
    };
    const updateYear = () => {
      years.querySelectorAll('button').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.menuBikeYear === year)));
      selection.textContent = record.brand + ' ' + record.modelDisplay + ' · ' + (year || dialog.dataset.prompt);
      apply.disabled = !year;
    };
    const showYears = () => {
      setStep('year');
      heading.textContent = dialog.dataset.yearTitle.replace('__model__', record.brand + ' ' + record.modelDisplay);
      back.hidden = context.models.length === 1;
      if (record.years.length === 1) year = record.years[0];
      years.replaceChildren(...record.years.map(value => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'pnm-menu-bike__year';
        button.dataset.menuBikeYear = value;
        button.textContent = value;
        return button;
      }));
      updateYear();
      (years.querySelector('[aria-pressed="true"]') || years.firstElementChild)?.focus();
      status.textContent = heading.textContent;
    };
    const getContext = anchor => {
      const api = window.PNMCollectionYear;
      if (!api?.selectFromMenu || !api.context) return null;
      let url;
      try { url = new URL(anchor.href, location.origin); } catch (_) { return null; }
      if (url.origin !== location.origin || url.search || url.hash || !/^\/collections\/[^/]+\/?$/.test(url.pathname)) return null;
      const path = url.pathname.replace(/\/$/, '');
      const result = api.context(path, new URLSearchParams());
      if (!result?.models.some(item => item.baseURL === path || item.target === path)) return null;
      return result;
    };
    const decorateLinks = () => {
      document.querySelectorAll('[data-pnm-nav] .pnm-model-list a, [data-pnm-nav] .pnm-family-heading > a').forEach(anchor => {
        if (!getContext(anchor)) return;
        anchor.setAttribute('aria-haspopup', 'dialog');
        anchor.setAttribute('aria-controls', dialog.id);
      });
    };
    document.addEventListener('click', event => {
      const anchor = event.target.closest?.('[data-pnm-nav] .pnm-model-list a, [data-pnm-nav] .pnm-family-heading > a');
      if (!anchor || event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || (anchor.target && anchor.target !== '_self')) return;
      const next = getContext(anchor);
      if (!next || typeof dialog.showModal !== 'function') return;
      event.preventDefault();
      context = next;
      lastTrigger = anchor;
      record = context.bike ? context.models.find(item => item.key === context.bike.key) : null;
      year = '';
      browse.href = context.base;
      browse.textContent = dialog.dataset.browseLabel.replace('__collection__', context.label);
      dialog.showModal();
      if (record || context.models.length === 1) {
        record = record || context.models[0];
        showYears();
      } else showModels();
    }, {capture:true, signal:controller.signal});
    dialog.addEventListener('click', event => {
      const button = event.target.closest('button');
      if (button?.hasAttribute('data-menu-bike-close')) dialog.close();
      else if (button?.hasAttribute('data-menu-bike-back')) showModels();
      else if (button?.dataset.menuBikeModel) {
        const next = context.models.find(item => item.key === button.dataset.menuBikeModel);
        if (next.key !== record?.key) year = '';
        record = next;
        showYears();
      } else if (button?.dataset.menuBikeYear) {
        year = button.dataset.menuBikeYear;
        updateYear();
        status.textContent = selection.textContent;
      } else if (button?.hasAttribute('data-menu-bike-apply') && year) {
        if (!window.PNMCollectionYear.selectFromMenu(context.base, record.key, year)) {
          error.textContent = dialog.dataset.error;
          error.hidden = false;
        }
      } else if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
      }
    }, {signal:controller.signal});
    dialog.addEventListener('close', () => {
      if (!lastTrigger?.isConnected) return;
      const target = lastTrigger.getClientRects().length ? lastTrigger : lastTrigger.closest('[data-pnm-nav]')?.querySelector('.pnm-root-toggle');
      target?.focus({preventScroll:true});
    }, {signal:controller.signal});
    window.addEventListener('pnm:bike-change', decorateLinks, {signal:controller.signal});
    decorateLinks();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true});
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-mobile-clean-orange"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.pnmMobileCleanOrangeReady) return;
  window.pnmMobileCleanOrangeReady = true;
  const selector = '.product-card.layout-1.pnm-card[data-product-card]';
  const viewport = window.matchMedia('(max-width: 767px)');
  let queued = false;

  function titleParts(original) {
    let name = original.replace(/\s+/g, ' ').trim();
    let models = '';
    let spec = '';
    const suffix = name.match(/\s+[-–—]\s*((?:Replaces|Genuine|OEM|Ref(?:erence)?\b|\d+(?:\.\d+)?\s*(?:mm|cm|inch|inches|litre|liter|ml|oz)\b).*)$/i);
    if (suffix) {
      spec = suffix[1].trim();
      name = name.slice(0, suffix.index).trim();
    }
    const pack = name.match(/\s+(Pk\/\d+)\s*[-–—]\s*(\d+(?:\.\d+)?\s*mm)$/i);
    if (pack) {
      spec = [pack[2], pack[1], spec].filter(Boolean).join(' · ');
      name = name.slice(0, pack.index).trim();
    }
    if (/^(?:(?:19|20)\d{2}(?:[-–]\d{2,4})?\s+)?(?:Honda|Yamaha|Kawasaki|Suzuki|Universal)\b/i.test(name)) {
      const start = name;
      let length = 0;
      const token = /^(?:(?:Honda|Yamaha|Kawasaki|Suzuki|Universal|Motorcycle|Motorcycles|Gold Wing|Goldwing)\b|(?:19|20)\d{2}(?:[-–]\d{2,4})?\b|[A-Z]{1,5}\d{2,4}[A-Z0-9]*(?:\/[A-Z]{0,5}\d{2,4}[A-Z0-9]*)?\b|\((?:19|20)\d{2}[\d\s,–-]*\))\s*[,/&]?\s*/;
      let match;
      while ((match = name.match(token)) && match[0].length) {
        length += match[0].length;
        name = name.slice(match[0].length);
      }
      if (name.trim()) models = start.slice(0, length).replace(/[,/&\s]+$/, '').replace(/\bMotorcycles?\b/g, '').replace(/\s+/g, ' ').trim();
      else name = start;
    }
    if (models === 'Universal' && spec) {
      spec += ' · ' + models;
      models = '';
    }
    return { name: name || original, models, spec };
  }

  function enhance(card) {
    if (card.hasAttribute('data-pnm-cj360-pilot')) {
      if (!card.classList.contains('pnm-mobile-clean')) card.classList.add('pnm-mobile-clean');
      return;
    }
    const link = card.querySelector('.product-title a');
    if (!link) return;
    const existing = link.querySelector('.pnm-original-card-title');
    const original = (existing ? existing.textContent : link.textContent).trim();
    if (!original) return;
    if (!card.classList.contains('pnm-mobile-clean')) card.classList.add('pnm-mobile-clean');
    if (link.getAttribute('data-pnm-mobile-source') === original) return;
    const parts = titleParts(original);
    let full = existing;
    if (!full) {
      full = document.createElement('span');
      full.className = 'pnm-original-card-title';
      while (link.firstChild) full.append(link.firstChild);
      link.append(full);
    }
    link.querySelector('.pnm-mobile-card-title')?.remove();
    const mobile = document.createElement('span');
    mobile.className = 'pnm-mobile-card-title';
    mobile.setAttribute('aria-hidden', 'true');
    [['name', parts.name], ['models', parts.models], ['spec', parts.spec]].forEach(([kind, text]) => {
      if (!text) return;
      const span = document.createElement('span');
      span.className = 'pnm-mobile-card-' + kind;
      span.textContent = text;
      mobile.append(span);
    });
    link.append(mobile);
    link.setAttribute('aria-label', original);
    link.setAttribute('data-pnm-mobile-source', original);
  }

  function sync() {
    queued = false;
    if (!viewport.matches) return;
    document.querySelectorAll(selector).forEach(enhance);
  }
  function schedule() {
    if (queued || !viewport.matches) return;
    queued = true;
    requestAnimationFrame(sync);
  }
  function start() {
    sync();
    const main = document.getElementById('MainContent') || document.body;
    new MutationObserver(records => {
      if (records.some(record => {
        const element = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        return element?.closest('.product-card') || Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches?.(selector) || node.querySelector?.(selector)));
      })) schedule();
    }).observe(main, { childList: true, subtree: true, characterData: true });
    viewport.addEventListener('change', schedule);
    window.addEventListener('globoFilterRenderCompleted', schedule);
    document.addEventListener('shopify:section:load', schedule);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-mobile-header-layout"] && !Shopify.designMode) return;
  try {
    (() => {
  const viewport = window.matchMedia('(max-width: 1024px)');
  let header = null;
  let resizeObserver = null;
  let stateObserver = null;
  let frame = 0;
  let previousHeight = '';

  function measure() {
    frame = 0;
    if (!viewport.matches || !header?.isConnected) return;
    const height = Math.ceil(header.getBoundingClientRect().height);
    if (height <= 0) return;
    const value = height + 'px';
    if (value === previousHeight) return;
    document.documentElement.style.setProperty('--pnm-mobile-header-height', value);
    previousHeight = value;
  }

  function schedule() {
    if (!frame) frame = requestAnimationFrame(measure);
  }

  function connect() {
    const next = document.querySelector('.site-header.header-sticky');
    if (header === next) {
      schedule();
      return;
    }
    resizeObserver?.disconnect();
    stateObserver?.disconnect();
    header = next;
    previousHeight = '';
    if (!header) return;
    resizeObserver = new ResizeObserver(schedule);
    resizeObserver.observe(header);
    stateObserver = new MutationObserver(schedule);
    stateObserver.observe(header, { attributes: true, attributeFilter: ['class'] });
    schedule();
  }

  viewport.addEventListener('change', schedule);
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', connect);
  window.addEventListener('pageshow', connect);
  document.addEventListener('shopify:section:load', connect);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', connect, { once: true });
  } else {
    connect();
  }
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-mobile-model-lists"] && !Shopify.designMode) return;
  try {
    (() => {
  const candidates = '.collection-description nav[aria-label*="model" i],.pnm-copy-model-navigation > nav,.pnm-catalog-models__content > nav';
  const mobile = window.matchMedia('(max-width:767px)');
  const labels = JSON.parse(document.querySelector('[data-pnm-mobile-model-config]').textContent);
  const active = new Set();
  let scheduled = false;
  const restore = state => {
    if (state.navigationAnchor.isConnected) {
      state.summary.firstElementChild.textContent = state.originalLabel;
      if (state.heading && state.headingAnchor.isConnected) state.headingAnchor.replaceWith(state.heading);
      state.navigationAnchor.replaceWith(state.navigation);
      state.nested.forEach(([details, wasOpen]) => { details.open = wasOpen; });
      state.disclosure.remove();
    }
    active.delete(state);
  };
  const wrap = navigation => {
    if (navigation.closest('.pnm-mobile-model-list') || !navigation.querySelector('a[href*="/collections/"]')) return;
    const previous = navigation.previousElementSibling;
    const heading = previous?.matches('h2,h3,h4') ? previous : null;
    const label = heading?.textContent.trim() || navigation.getAttribute('aria-label')?.trim();
    if (!label) return;
    const disclosure = document.createElement('details');
    disclosure.className = 'pnm-mobile-model-list';
    const summary = document.createElement('summary');
    const navigationAnchor = document.createComment('pnm-model-navigation');
    const headingAnchor = heading ? document.createComment('pnm-model-heading') : null;
    navigation.before(navigationAnchor);
    if (heading) {
      heading.before(headingAnchor);
      summary.append(heading);
    } else {
      const text = document.createElement('span');
      text.textContent = label;
      summary.append(text);
    }
    navigationAnchor.after(disclosure);
    disclosure.append(summary,navigation);
    const nested = [...navigation.querySelectorAll('details:not(.pnm-model-year)')].map(details => [details,details.open]);
    nested.forEach(([details]) => { details.open = true; });
    disclosure.addEventListener('toggle',() => {
      if (!disclosure.open) navigation.querySelectorAll('.pnm-model-year[open]').forEach(details => { details.open = false; });
    });
    const originalLabel = summary.firstElementChild.textContent;
    summary.addEventListener('click',event => {
      if (disclosure.dataset.hasBike !== 'true' || !window.PNMBikeSelector?.open) return;
      event.preventDefault();
      window.PNMBikeSelector.open(summary);
    });
    active.add({disclosure,navigation,navigationAnchor,heading,headingAnchor,nested,summary,originalLabel});
  };
  const sync = () => {
    scheduled = false;
    for (const state of active) {
      if (!state.disclosure.isConnected) active.delete(state);
      else if (!mobile.matches) restore(state);
    }
    if (mobile.matches) document.querySelectorAll(candidates).forEach(wrap);
    const bike = window.PNMCollectionYear?.context()?.bike;
    for (const state of active) {
      const hasBike = Boolean(bike?.bikeYear);
      state.disclosure.dataset.hasBike = String(hasBike);
      const text = hasBike ? labels.change : state.originalLabel;
      if (state.summary.firstElementChild.textContent !== text) state.summary.firstElementChild.textContent = text;
      if (hasBike) {
        state.disclosure.open = false;
        state.summary.setAttribute('aria-haspopup','dialog');
        state.summary.setAttribute('aria-controls','pnm-model-dialog');
      } else {
        state.summary.removeAttribute('aria-haspopup');
        state.summary.removeAttribute('aria-controls');
      }
    }
  };
  const schedule = () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(sync);
    }
  };
  const start = () => {
    sync();
    const root = document.getElementById('MainContent');
    if (!root) return;
    new MutationObserver(records => {
      if (mobile.matches && records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && !node.closest('.pnm-mobile-model-list') && (node.matches(candidates) || node.querySelector(candidates))))) schedule();
    }).observe(root,{childList:true,subtree:true});
  };
  mobile.addEventListener('change',sync);
  document.addEventListener('shopify:section:load',schedule);
  window.addEventListener('pageshow',schedule);
  window.addEventListener('pnm:bike-change',schedule);
  window.addEventListener('globoFilterRenderCompleted',schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-model-year-dropdowns"] && !Shopify.designMode) return;
  try {
    (() => {
    const start = () => {
      const root = document.querySelector('[data-pnm-complete-models]');
      if (!root || root.dataset.yearsReady) return;
      root.dataset.yearsReady = 'true';
      const menus = [...root.querySelectorAll('.pnm-model-year')];
      const mobileYears = window.matchMedia('(max-width: 767px)');
      const close = menu => { menu.open = false; };
      const position = menu => {
        // Mobile uses an in-flow panel; scrolling must not reposition or close it.
        if (!menu.open || mobileYears.matches) return;
        const trigger = menu.querySelector('summary').getBoundingClientRect();
        const popup = menu.querySelector('.pnm-model-year__popover');
        if (trigger.bottom < 0 || trigger.top > innerHeight) { close(menu); return; }
        const gap = 7, edge = 12;
        const width = Math.min(340, document.documentElement.clientWidth - edge * 2);
        popup.style.width = width + 'px';
        popup.style.left = Math.max(edge, Math.min(trigger.left, document.documentElement.clientWidth - width - edge)) + 'px';
        const below = innerHeight - trigger.bottom - gap - edge;
        const above = trigger.top - gap - edge;
        const useBelow = below >= Math.min(popup.scrollHeight, 240) || below >= above;
        const space = Math.max(100, useBelow ? below : above);
        popup.style.maxHeight = Math.min(400, space) + 'px';
        popup.style.top = (useBelow ? trigger.bottom + gap : Math.max(edge, trigger.top - gap - popup.getBoundingClientRect().height)) + 'px';
      };
      const sync = () => {
        const bike = window.PNMCollectionYear?.context()?.bike;
        menus.forEach(menu => {
          const label = menu.querySelector('[data-pnm-model-label]');
          const active = bike?.brand === root.dataset.pnmModelBrand && bike.modelType === menu.dataset.pnmModelCode;
          const year = active ? bike.bikeYear : '';
          menu.dataset.selected = String(Boolean(active));
          label.textContent = label.dataset.label + (year ? ' · ' + year : '');
          menu.querySelectorAll('[data-pnm-year]').forEach(button => {
            if (year && button.dataset.pnmYear === year) button.setAttribute('aria-current', 'true');
            else button.removeAttribute('aria-current');
          });
        });
      };
      menus.forEach(menu => {
        menu.addEventListener('toggle', () => {
          if (!menu.open) return;
          menus.filter(other => other !== menu).forEach(close);
          position(menu);
        });
        menu.addEventListener('keydown', event => {
          if (event.key === 'Escape' && menu.open) {
            event.preventDefault();
            close(menu);
            menu.querySelector('summary').focus();
          }
        });
        menu.addEventListener('focusout', event => {
          if (!mobileYears.matches && event.relatedTarget && !menu.contains(event.relatedTarget)) close(menu);
        });
        menu.querySelector('[data-pnm-close-years]').addEventListener('click', () => {
          close(menu);
          menu.querySelector('summary').focus();
        });
        // Year navigation works natively; JavaScript only carries an explicit draft preview ID.
        const preview = new URL(location.href).searchParams.get('preview_theme_id');
        if (preview) menu.querySelectorAll('a[data-pnm-year]').forEach(link => {
          const target = new URL(link.href);
          target.searchParams.set('preview_theme_id', preview);
          link.href = target.href;
        });
      });
      document.addEventListener('click', event => {
        menus.filter(menu => menu.open && !menu.contains(event.target)).forEach(close);
      });
      let frame;
      const reposition = event => {
        if (event?.target instanceof Element && event.target.closest('.pnm-model-year__popover')) return;
        if (frame) return;
        frame = requestAnimationFrame(() => { frame = null; menus.forEach(position); });
      };
      window.addEventListener('scroll', reposition, { passive: true, capture: true });
      window.addEventListener('resize', reposition);
      window.addEventListener('pnm:bike-change', sync);
      window.addEventListener('popstate', sync);
      window.addEventListener('pageshow', () => { root.removeAttribute('aria-busy'); menus.forEach(close); sync(); });
      sync();
    };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
    else start();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-product-cards"] && !Shopify.designMode) return;
  try {
    (() => {
  if (window.pnmCardDetailsReady) return;
  window.pnmCardDetailsReady = true;

  const configNode = document.querySelector('[data-pnm-card-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const cardSelector = '.product-card.pnm-card';
  const heartSelector = '.product_wishlist[data-icon-wishlist][data-product-handle]';
  let scheduled = false;
  let layoutPending = true;
  let lastCurrency = '';

  function selectedCurrency() {
    try {
      const code = window.tms?.selectorApi?.currency?.code;
      if (/^[A-Z]{3}$/.test(code || '')) return code;
    } catch (error) {}
    return config.currency;
  }

  function syncCurrency() {
    const code = selectedCurrency();
    lastCurrency = code;
    document.querySelectorAll(cardSelector + ' .product-price[data-price]').forEach(price => {
      const regular = price.querySelector('[data-regular-price]');
      const sale = price.querySelector('[data-sale-price]');
      const current = price.classList.contains('price--on-sale') && sale?.textContent.trim() ? sale : regular;
      if (!current) return;
      let amount = price.querySelector('[data-pnm-card-price-amount]');
      if (!amount) {
        amount = document.createElement('span');
        amount.className = 'pnm-card-price-amount';
        amount.setAttribute('data-pnm-card-price-amount', '');
        price.prepend(amount);
      }
      amount.querySelectorAll('.price-item').forEach(item => {
        if (item !== current) price.insertBefore(item, amount.nextSibling);
      });
      if (current.parentElement !== amount) amount.prepend(current);
      let label = price.querySelector('[data-pnm-card-currency]');
      if (!label) {
        label = document.createElement('span');
        label.className = 'pnm-card-currency notranslate';
        label.setAttribute('translate', 'no');
        label.setAttribute('data-pnm-card-currency', '');
      }
      if (label.parentElement !== amount) amount.appendChild(label);
      if (label.textContent !== code) label.textContent = code;
      const unit = price.querySelector('.pnm-card-unit');
      if (unit && unit.parentElement !== amount) amount.appendChild(unit);
    });
  }

  function savedHandles() {
    try {
      const items = JSON.parse(localStorage.getItem('items') || '[]');
      return Array.isArray(items) ? new Set(items) : null;
    } catch (error) {
      return null;
    }
  }

  function syncHearts() {
    const saved = savedHandles();
    if (!saved) return;
    document.querySelectorAll(heartSelector).forEach(heart => {
      const active = saved.has(heart.getAttribute('data-product-handle'));
      if (heart.classList.contains('whislist-added') !== active) {
        heart.classList.toggle('whislist-added', active);
      }
      const pressed = String(active);
      if (heart.getAttribute('aria-pressed') !== pressed) heart.setAttribute('aria-pressed', pressed);
      if (heart.getAttribute('role') !== 'button') heart.setAttribute('role', 'button');
      const title = heart.closest('.product-card')?.querySelector('.product-title')?.textContent.trim() || '';
      const label = (active ? config.removeLabel : config.addLabel) + (title ? ': ' + title : '');
      if (heart.getAttribute('aria-label') !== label) heart.setAttribute('aria-label', label);
      if (heart.getAttribute('title') !== label) heart.setAttribute('title', label);
    });
  }

  function prepareFooter(card) {
      const price = card.querySelector('.product-price[data-price]');
      if (!price) return;
      let purchase = price.closest('[data-pnm-card-purchase]');
      if (!purchase) {
        purchase = document.createElement('div');
        purchase.className = 'pnm-card-purchase';
        purchase.setAttribute('data-pnm-card-purchase', '');
        const inner = document.createElement('div');
        inner.className = 'pnm-card-purchase-inner';
        const savings = price.parentElement.querySelector('.product-price-savings');
        price.before(purchase);
        purchase.appendChild(inner);
        inner.appendChild(price);
        if (savings) inner.appendChild(savings);
      }
      // Keep fitment with the price so title length cannot split purchase details.
      let fitmentSlot = purchase.querySelector('[data-pnm-card-fitment-slot]');
      if (card.closest('#gf-grid, #collection-page')) {
        if (!fitmentSlot) {
          fitmentSlot = document.createElement('div');
          fitmentSlot.className = 'pnm-card-fitment-slot';
          fitmentSlot.setAttribute('data-pnm-card-fitment-slot', '');
          purchase.firstElementChild.prepend(fitmentSlot);
        }
        const fitment = card.querySelector('[data-pnm-card-fitment]');
        if (fitment && fitment.parentElement !== fitmentSlot) fitmentSlot.appendChild(fitment);
      }
      return { card, purchase, fitmentSlot };
  }

  function syncFooters() {
    const rowsByGrid = new Map();
    function measureFooter(prepared) {
      if (!prepared) return;
      const { card, purchase, fitmentSlot } = prepared;
      if (!card.getClientRects().length) return;
      const item = card.parentElement;
      const grid = item.parentElement;
      const rowTop = item.offsetTop;
      if (!rowsByGrid.has(grid)) rowsByGrid.set(grid, []);
      const rows = rowsByGrid.get(grid);
      let row = rows.find(entry => Math.abs(entry.top - rowTop) < 2);
      if (!row) { row = { top: rowTop, cards: [], purchase: 0, fitment: 0, actions: 0 }; rows.push(row); }
      const actions = card.querySelector(':scope > .product-actions');
      const fitment = fitmentSlot?.querySelector('[data-pnm-card-fitment]');
      let fitmentHeight = 0;
      if (fitment && !fitment.hidden && fitment.getClientRects().length) {
        const fitmentStyle = getComputedStyle(fitment);
        fitmentHeight = fitment.offsetHeight + (parseFloat(fitmentStyle.marginTop) || 0) + (parseFloat(fitmentStyle.marginBottom) || 0);
      }
      // Measure the badge independently of its reserved row height so it can shrink.
      const purchaseHeight = purchase.firstElementChild.offsetHeight - (fitmentSlot?.offsetHeight || 0);
      const actionsHeight = actions ? Array.from(actions.children).reduce((total, child) => {
        const style = getComputedStyle(child);
        if (style.position === 'absolute' || style.display === 'none') return total;
        return total + child.offsetHeight + (parseFloat(style.marginTop) || 0) + (parseFloat(style.marginBottom) || 0);
      }, 0) : 0;
      row.cards.push(card);
      row.purchase = Math.max(row.purchase, purchaseHeight);
      row.fitment = Math.max(row.fitment, fitmentHeight);
      row.actions = Math.max(row.actions, actionsHeight);
    }
    const cards = document.querySelectorAll(cardSelector);
    if (config.homepage) {
      // Finish structural writes across the carousel before reading layout.
      const prepared = Array.from(cards, prepareFooter);
      prepared.forEach(measureFooter);
    } else {
      cards.forEach(card => measureFooter(prepareFooter(card)));
    }
    rowsByGrid.forEach(rows => rows.forEach(row => row.cards.forEach(card => {
      const heights = { '--pnm-card-purchase-height': row.purchase + row.fitment, '--pnm-card-fitment-height': row.fitment, '--pnm-card-actions-height': row.actions };
      Object.entries(heights).forEach(([name, height]) => {
        const value = height + 'px';
        if (card.style.getPropertyValue(name) !== value) card.style.setProperty(name, value);
      });
    })));
  }

  function sync() {
    scheduled = false;
    syncCurrency();
    syncHearts();
    if (!config.homepage || layoutPending) {
      layoutPending = false;
      syncFooters();
    }
  }

  function schedule(needsLayout = true) {
    if (needsLayout !== false) layoutPending = true;
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }

  function start() {
    sync();
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('globoFilterRenderCompleted', schedule);
    document.addEventListener('shopify:section:load', schedule);
    if (document.fonts) document.fonts.ready.then(schedule);
    new MutationObserver(records => {
      let detailsChanged = false;
      const relevant = records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (!target || target.closest('[data-pnm-card-currency]')) return false;
        // Wishlist state changes do not alter the homepage card dimensions.
        if (config.homepage && record.type === 'attributes' && target.matches(heartSelector)) {
          detailsChanged = true;
          return false;
        }
        if (target === document.body || target.closest('.product-card, .ht-tms-selector')) return true;
        return Array.from(record.addedNodes || []).some(node =>
          node.nodeType === 1 && (node.matches('.product-card, .ht-tms-selector') ||
          node.querySelector('.product-card, .ht-tms-selector'))
        );
      });
      if (relevant) schedule();
      else if (detailsChanged) schedule(false);
    }).observe(document.body, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class', 'data-value'] });

    window.addEventListener('storage', event => {
      if (event.key === 'items' || event.key === null) schedule(!config.homepage);
    });
    document.addEventListener('visibilitychange', () => {
      if (!document.hidden) schedule();
    });
    document.addEventListener('keydown', event => {
      const heart = event.target.closest(heartSelector);
      if (heart && event.key === ' ' && heart.tagName === 'A') {
        event.preventDefault();
        heart.click();
      }
    });
    setInterval(() => {
      if (!document.hidden && selectedCurrency() !== lastCurrency) syncCurrency();
    }, 1500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-product-currency"] && !Shopify.designMode) return;
  try {
    (() => {
  let frame = 0;
  const labelSelector = '[data-pnm-product-currency]';
  function syncCurrency() {
    frame = 0;
    let selected = '';
    try { selected = window.tms?.selectorApi?.currency?.code || ''; } catch (_) {}
    if (!/^[A-Z]{3}$/.test(selected)) {
      selected = document.querySelector('[data-pnm-header-localization] .pnm-currency-code')?.textContent.trim() || '';
    }
    document.querySelectorAll(labelSelector).forEach(label => {
      const code = /^[A-Z]{3}$/.test(selected) ? selected : label.dataset.baseCurrency;
      if (label.textContent !== code) label.textContent = code;
    });
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(syncCurrency);
  }
  function start() {
    syncCurrency();
    new MutationObserver(records => {
      const relevant = records.some(record => {
        const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
        if (!target || target.closest(labelSelector)) return false;
        if (target.closest('[data-pnm-header-localization], .product_shop [data-price], [data-pnm-sticky-price]')) return true;
        return [...record.addedNodes].some(node => node.nodeType === 1 &&
          (node.matches(labelSelector + ', [data-pnm-header-localization]') ||
           node.querySelector(labelSelector + ', [data-pnm-header-localization]')));
      });
      if (relevant) schedule();
    }).observe(document.body, {childList:true, subtree:true, characterData:true});
    window.addEventListener('pageshow', schedule);
    document.addEventListener('shopify:section:load', schedule);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) schedule(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-product-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  function initialize() {
    document.querySelectorAll('[data-pnm-product]').forEach(root => {
      if (root.dataset.pnmReady) return;
      root.dataset.pnmReady = 'true';
      const page = root.closest('.pnm-product-page');
      const dataNode = root.querySelector('[data-pnm-product-data]');
      if (!page || !dataNode) return;
      let data;
      try { data = JSON.parse(dataNode.textContent); } catch (_) { return; }
      const normalize = value => String(value || '').trim().toUpperCase().replace(/\s+/g, ' ');
      const lines = value => Array.isArray(value) ? value.map(x => String(x).trim()) : String(value || '').replace(/\r/g, '').trim().split('\n').map(x => x.trim());
      const brands = lines(data.brands), models = lines(data.models), years = lines(data.years);
      const aligned = brands.length === models.length && models.length === years.length;
      const records = aligned ? models.map((model, i) => ({brand: brands[i], model, year: years[i]})).filter(row => row.brand && row.model && /^\d{4}$/.test(row.year)) : [];
      const universalValues = ['UNIVERSAL', 'CUSTOM / UNIVERSAL', 'UNIVERSAL/CUSTOM', 'CUSTOM/UNIVERSAL'];
      const universal = (data.tags || []).some(tag => universalValues.includes(normalize(tag))) || models.some(model => universalValues.includes(normalize(model)));
      const card = root.querySelector('[data-pnm-fitment-card]');
      const details = root.querySelector('[data-pnm-details]');
      const tabButtons = Array.from(details.querySelectorAll('[data-pnm-tab]'));
      function showPanel(name, focus = false) {
        if (!tabButtons.some(button => button.dataset.pnmTab === name)) return;
        tabButtons.forEach(button => { const selected = button.dataset.pnmTab === name; button.setAttribute('aria-selected', String(selected)); button.tabIndex = selected ? 0 : -1; });
        details.querySelectorAll('[data-pnm-panel]').forEach(panel => { panel.hidden = panel.dataset.pnmPanel !== name; panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', 'pnm-tab-' + panel.dataset.pnmPanel); });
        if (focus) { const panel = details.querySelector('[data-pnm-panel="' + name + '"]'); panel.focus({preventScroll:true}); panel.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'}); }
      }
      details.dataset.ready = 'true';
      details.querySelector('[role=tablist]').hidden = false;
      tabButtons.forEach((button, i) => {
        button.addEventListener('click', () => { if(button.dataset.pnmTab === 'fitment') viewSelectedFitment(); else showPanel(button.dataset.pnmTab); });
        button.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (i + 1) % tabButtons.length;
          if (event.key === 'ArrowLeft') next = (i + tabButtons.length - 1) % tabButtons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabButtons.length - 1;
          if (next !== undefined) { event.preventDefault(); showPanel(tabButtons[next].dataset.pnmTab); tabButtons[next].focus(); }
        });
      });
      showPanel(location.hash === '#pnm-fitment' ? 'fitment' : 'description');
      root.querySelector('[data-pnm-fitment-link]').addEventListener('click', event => { event.preventDefault(); viewSelectedFitment(); });
      details.querySelectorAll('[data-pnm-description-link]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); showPanel('description', true); }));
      const checkBike = root.querySelector('[data-pnm-check-bike]');
      checkBike.setAttribute('aria-haspopup', 'dialog');
      checkBike.setAttribute('aria-controls', 'pnm-model-dialog');
      checkBike.setAttribute('aria-expanded', 'false');
      checkBike.addEventListener('click', () => {
        if (!window.PNMBikeSelector?.check) { showPanel('fitment', true); return; }
        window.PNMBikeSelector.check(checkBike, () => {
          updateFitment();
          card.tabIndex = -1;
          card.focus({preventScroll:true});
          card.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});
        });
      });
      const grouped = new Map();
      records.forEach(row => { const key = normalize(row.brand) + '|' + normalize(row.model); if (!grouped.has(key)) grouped.set(key, {brand:row.brand,model:row.model,years:new Set()}); grouped.get(key).years.add(row.year); });
      function compactYears(values) {
        const list = Array.from(values).map(Number).sort((a,b) => a-b), parts=[];
        for (let i=0;i<list.length;i++) { const start=list[i]; let end=start; while (list[i+1]===end+1) end=list[++i]; parts.push(start===end?String(start):start+'–'+end); }
        return parts.join(', ');
      }
      const body = root.querySelector('[data-pnm-fitment-rows]');
      const brandOrder=['HONDA','YAMAHA','KAWASAKI','SUZUKI'];
      const sorted=Array.from(grouped.values()).sort((a,b) => {
        const ai=brandOrder.indexOf(normalize(a.brand)),bi=brandOrder.indexOf(normalize(b.brand));
        if(ai!==bi)return (ai<0?99:ai)-(bi<0?99:bi);
        return a.model.localeCompare(b.model,undefined,{numeric:true});
      });
      const fitmentRows = new Map();
      sorted.forEach(row => { const tr=document.createElement('tr'); fitmentRows.set(tr,row); [row.brand,row.model,compactYears(row.years)].forEach(value => { const td=document.createElement('td'); td.textContent=value; tr.append(td); }); tr.dataset.search=normalize(row.brand+' '+row.model+' '+Array.from(row.years).join(' ')); body.append(tr); });
      const fitmentSearch = root.querySelector('[data-pnm-fitment-search]');
      fitmentSearch.hidden = sorted.length <= 4;
      root.querySelector('label[for="pnm-fitment-search"]').hidden = fitmentSearch.hidden;
      root.querySelector('[data-pnm-fitment-table]').hidden = !sorted.length || universal;
      fitmentSearch.addEventListener('input', event => { const term=normalize(event.target.value); let count=0; Array.from(body.rows).forEach(row => { row.hidden=!row.dataset.search.includes(term); if(!row.hidden)count++; }); root.querySelector('[data-pnm-fitment-empty]').hidden=count>0; });
  function manufacturer(value) {
    const values = String(value || '').split(',').map(item => item.trim().replace(/ - ATV$/, ''));
    return values[0] && values.every(item => item === values[0]) ? values[0] : '';
  }

      function selection() {
        const bike=window.PNMBikeSelector?.selection?.();
        return bike?{brand:manufacturer(bike.brand),model:bike.model||'',year:bike.year||''}:{brand:'',model:'',year:''};
      }
      let highlightedBikeKey = null;
      const fitmentBikeKey = bike => JSON.stringify([normalize(bike.brand),normalize(bike.model),String(bike.year)]);
      function clearFitmentHighlight() {
        highlightedBikeKey = null;
        fitmentRows.forEach((record,row) => { row.classList.remove('pnm-fitment-selected'); row.removeAttribute('aria-current'); row.removeAttribute('tabindex'); });
      }
      function viewSelectedFitment() {
        const bike=selection();
        clearFitmentHighlight();
        fitmentSearch.value='';
        fitmentSearch.dispatchEvent(new Event('input',{bubbles:true}));
        const match=!universal && bike.brand && bike.model && Array.from(fitmentRows).find(([row,record]) => normalize(manufacturer(record.brand))===normalize(bike.brand) && normalize(record.model)===normalize(bike.model) && (!bike.year || record.years.has(String(bike.year))));
        if(!match){showPanel('fitment',true);return;}
        showPanel('fitment');
        const row=match[0];
        highlightedBikeKey=fitmentBikeKey(bike);
        row.classList.add('pnm-fitment-selected');
        row.setAttribute('aria-current','true');
        row.tabIndex=-1;
        requestAnimationFrame(() => {
          row.focus({preventScroll:true});
          row.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center',inline:'nearest'});
        });
      }
      function updateFitment() {
        const bike=selection(), s=data.strings;
        if(highlightedBikeKey && highlightedBikeKey!==fitmentBikeKey(bike)) clearFitmentHighlight();
        let title=s.fitment_title, note=s.fitment_note, state='neutral', icon='?';
        if(universal){title=s.universal;note=s.universal_note;state='universal';icon='!';}
        else if(bike.model && bike.year && bike.brand){
          const found=records.some(row=>normalize(manufacturer(row.brand))===normalize(bike.brand)&&normalize(row.model)===normalize(bike.model)&&row.year===bike.year);
          if(found){title=s.fits;note='';state='match';icon='✓';}
          else if(records.length){title=s.not_listed;note=s.not_listed_note;state='warning';icon='!';}
          else{title=s.unknown;note=s.unknown_note;}
        }else if(bike.model){title=s.choose_year;note=s.fitment_note;}
        card.dataset.state=state;
        card.querySelector('[data-pnm-fitment-title]').textContent=title;
        const noteElement=card.querySelector('[data-pnm-fitment-note]');
        noteElement.textContent=note;
        noteElement.hidden=!note;
        card.querySelector('.pnm-fitment-icon').textContent=icon;
        const label=card.querySelector('[data-pnm-selected-bike]');
        label.hidden=universal||!bike.model; label.textContent=[bike.year,bike.brand,bike.model].filter(Boolean).join(' ');
        const button=card.querySelector('[data-pnm-check-bike]');button.hidden=universal;button.textContent=bike.model?s.change_bike:s.select_bike;
        const universalNotice=details.querySelector('[data-pnm-universal-notice]');
        if(universalNotice) universalNotice.hidden=!universal;
        const fitmentHelp=details.querySelector('[data-pnm-fitment-help]');
        if(fitmentHelp) fitmentHelp.hidden=universal;
        const fitmentFootnote=details.querySelector('.pnm-fitment-footnote');
        if(fitmentFootnote) fitmentFootnote.hidden=universal;
      }
      updateFitment();
      window.addEventListener('pnm:bike-change',updateFitment);
      window.addEventListener('storage',updateFitment);
      window.addEventListener('popstate',updateFitment);
      const rating=root.querySelector('[data-pnm-rating]');
      if(rating){const updateRating=()=>{const badge=rating.querySelector('[data-number-of-reviews]');rating.hidden=!(badge&&Number(badge.getAttribute('data-number-of-reviews'))>0);};updateRating();new MutationObserver(updateRating).observe(rating,{childList:true,subtree:true,attributes:true,attributeFilter:['data-number-of-reviews']});}
      const form=root.querySelector('form[data-product-form]'), add=form?.querySelector('[data-add-to-cart]'), quantity=form?.querySelector('[name=quantity]');
      const availability=root.querySelector('[data-pnm-availability]'), sticky=page.querySelector('[data-pnm-sticky]');
      if(!form||!add)return;
      const price=root.querySelector('.product_shop .product-price');
      const setText=(node,text)=>{if(node && node.textContent!==text)node.textContent=text;};
      function sync() {
        const id=form.querySelector('[name=id]')?.value;
        const variant=data.variants.find(item=>String(item.id)===String(id));
        if(variant){
          let state='stock',text=availability.dataset.stock,note='';
          if(!variant.available){state='sold';text=availability.dataset.soldOut;note='';}
          else if(!variant.tracked){state='available';text=availability.dataset.available;note='';}
          else if(variant.quantity<=0){state='order';text=availability.dataset.preorder;note=availability.dataset.preorderNote;}
          if(availability.dataset.state!==state)availability.dataset.state=state;setText(availability.querySelector('[data-pnm-stock]'),text);setText(availability.querySelector('[data-pnm-dispatch]'),note);
          if(!variant.available&&!add.disabled)add.disabled=true;
        }
        if(sticky){
          const stickyButton=sticky.querySelector('[data-pnm-sticky-submit]');if(stickyButton.disabled!==add.disabled)stickyButton.disabled=add.disabled;
          setText(stickyButton,add.querySelector('[data-add-to-cart-text]')?.textContent.trim()||add.textContent.trim());
          setText(sticky.querySelector('[data-pnm-sticky-quantity]'),quantity?.value||'1');
          if(price){const candidates=Array.from(price.querySelectorAll('.price-item'));const visible=candidates.filter(node=>node.getClientRects().length&&node.textContent.trim());const current=visible.find(node=>node.classList.contains('price-item--sale'))||visible[0];if(current)setText(sticky.querySelector('[data-pnm-sticky-price]'),current.textContent.trim());}
        }
      }
      let queued=false;
      const schedule=()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;sync();});};
      form.addEventListener('change',schedule);form.addEventListener('input',schedule);form.addEventListener('click',schedule);
      new MutationObserver(schedule).observe(add,{childList:true,subtree:true,attributes:true,attributeFilter:['disabled','class']});
      if(price)new MutationObserver(schedule).observe(price,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['class']});
      form.addEventListener('submit',event=>{if(quantity&&(!/^\d+$/.test(quantity.value)||Number(quantity.value)<1)){event.preventDefault();event.stopImmediatePropagation();quantity.value='1';quantity.focus();}},true);
      if(sticky){
        sticky.querySelector('[data-pnm-sticky-submit]').addEventListener('click',()=>{sync();if(!add.disabled)add.click();});
        new IntersectionObserver(entries=>{const entry=entries[0];const visible=!entry.isIntersecting&&entry.boundingClientRect.bottom<0;sticky.hidden=!visible;document.body.classList.toggle('pnm-sticky-visible',visible);},{threshold:0}).observe(add);
      }
      sync();
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize);else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-product-gallery-controls"] && !Shopify.designMode) return;
  try {
    (() => {
  const initialize = () => document.querySelectorAll('[data-pnm-product]').forEach(root => {
    if (root.dataset.fullGalleryReady) return;
    root.dataset.fullGalleryReady = 'true';
    const dialog = root.querySelector('[data-pnm-media-dialog]');
    const stage = root.querySelector('[data-pnm-media-stage]');
    const templates = [...root.querySelectorAll('[data-pnm-full-media]')];
    if (!dialog || !stage || !templates.length) return;
    const count = root.querySelector('[data-pnm-gallery-count]');
    const touch = window.matchMedia('(pointer: coarse)');
    const tip = root.querySelector('[data-pnm-gallery-tip]');
    const fullTip = root.querySelector('[data-pnm-full-tip]');
    const instruction = (type, full) => type === 'model' ? (full ? (touch.matches ? root.dataset.modelTouch : root.dataset.modelDesktop) : root.dataset.openMedia) : type === 'image' ? (full ? (touch.matches ? root.dataset.fullPhotoTouch : root.dataset.fullPhotoDesktop) : (touch.matches ? root.dataset.photoTouch : root.dataset.photoDesktop)) : root.dataset.openMedia;
    let pageIndex = 0, fullIndex = 0, previousFocus, oldOverflow;
    const wrap = index => (index + templates.length) % templates.length;
    const updateCount = index => { pageIndex = wrap(index); if(count) count.textContent = (pageIndex + 1) + ' / ' + templates.length; if(tip) tip.textContent = instruction(templates[pageIndex].dataset.mediaType, false); };
    const getSlider = () => {
      const $ = window.jQuery;
      return $ && $.fn.slick ? $(root).find('.slider-for.slick-initialized') : null;
    };
    const goTo = index => {
      updateCount(index);
      const slider = getSlider();
      if (slider && slider.length) slider.slick('slickGoTo', pageIndex);
    };
    const bindSlider = () => {
      const $ = window.jQuery;
      if (!$) return;
      $(root).find('.slider-for').off('afterChange.pnmGallery').on('afterChange.pnmGallery', (event, slick, index) => updateCount(index));
    };
    bindSlider();
    window.addEventListener('load', bindSlider, {once:true});
    const showMedia = index => {
      fullIndex = wrap(index);
      stage.querySelectorAll('video').forEach(video => video.pause());
      stage.replaceChildren(templates[fullIndex].content.cloneNode(true));
      stage.dataset.mediaType = templates[fullIndex].dataset.mediaType;
      if (fullTip) fullTip.textContent = instruction(stage.dataset.mediaType, true);
      dialog.querySelectorAll('[data-pnm-full-thumb]').forEach(button => {
        const active = Number(button.dataset.pnmFullThumb) === fullIndex;
        button.setAttribute('aria-pressed', String(active));
        if (active) {
          const strip = button.parentElement;
          if (button.offsetLeft < strip.scrollLeft || button.offsetLeft + button.offsetWidth > strip.scrollLeft + strip.clientWidth) strip.scrollLeft = button.offsetLeft - (strip.clientWidth - button.offsetWidth) / 2;
        }
      });
      dialog.querySelector('[data-pnm-full-count]').textContent = (fullIndex + 1) + ' / ' + templates.length + (templates[fullIndex].dataset.mediaType === 'model' ? ' · 3D' : '');
      if (templates[fullIndex].dataset.mediaType === 'model' && !customElements.get('model-viewer') && window.Shopify && Shopify.loadFeatures) {
        Shopify.loadFeatures([{name:'model-viewer-ui',version:'1.0'}]);
      }
      goTo(fullIndex);
    };
    const open = index => {
      previousFocus = document.activeElement;
      if (!dialog.open) {oldOverflow = document.documentElement.style.overflow;dialog.showModal();document.documentElement.style.overflow = 'hidden';}
      showMedia(index);
      dialog.querySelector('[data-pnm-media-close]').focus();
    };
    root.addEventListener('click', event => {
      const thumb = event.target.closest('[data-pnm-gallery-index]');
      if (thumb) {
        event.preventDefault();event.stopPropagation();
        const index = Number(thumb.dataset.pnmGalleryIndex);goTo(index);
        if (thumb.dataset.pnmMediaType === 'model') open(index);
        return;
      }
      const trigger = event.target.closest('[data-pnm-open-media]');
      if (trigger) {event.preventDefault();event.stopPropagation();open(Number(trigger.dataset.pnmOpenMedia));return;}
      const pageStep = event.target.closest('[data-pnm-page-step]');
      if (pageStep) {
        const slider = getSlider();
        const current = slider && slider.length ? slider.slick('slickCurrentSlide') : pageIndex;
        goTo(current + Number(pageStep.dataset.pnmPageStep));
      }
      const fullThumb = event.target.closest('[data-pnm-full-thumb]');
      if (fullThumb) showMedia(Number(fullThumb.dataset.pnmFullThumb));
      const fullStep = event.target.closest('[data-pnm-full-step]');
      if (fullStep) showMedia(fullIndex + Number(fullStep.dataset.pnmFullStep));
      if (event.target.closest('[data-pnm-media-close]')) dialog.close();
    }, true);
    root.addEventListener('keydown', event => {
      const trigger = event.target.closest('[data-pnm-open-media]');
      if (trigger && (event.key === 'Enter' || event.key === ' ')) {event.preventDefault();open(Number(trigger.dataset.pnmOpenMedia));}
    });
    let swipe = null;
    const pointers = new Set();
    stage.addEventListener('pointerdown', event => {
      if (event.pointerType !== 'touch') return;
      pointers.add(event.pointerId);
      if (pointers.size !== 1 || stage.dataset.mediaType !== 'image') {swipe = null;return;}
      swipe = {id:event.pointerId,x:event.clientX,y:event.clientY,time:Date.now()};
    });
    stage.addEventListener('pointerup', event => {
      pointers.delete(event.pointerId);
      const start = swipe; swipe = null;
      if (!start || start.id !== event.pointerId || pointers.size || stage.dataset.mediaType !== 'image') return;
      const dx = event.clientX - start.x, dy = event.clientY - start.y;
      if (Math.abs(dx) >= 50 && Math.abs(dx) > Math.abs(dy) * 1.5 && Date.now() - start.time < 900) showMedia(fullIndex + (dx < 0 ? 1 : -1));
    });
    stage.addEventListener('pointercancel', event => {pointers.delete(event.pointerId);swipe = null;});
    updateCount(0);
    dialog.addEventListener('keydown', event => {
      if (event.target.closest('model-viewer,video,iframe')) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {event.preventDefault();showMedia(fullIndex + (event.key === 'ArrowRight' ? 1 : -1));}
    });
    dialog.addEventListener('close', () => {stage.querySelectorAll('video').forEach(video=>video.pause());stage.replaceChildren();document.documentElement.style.overflow = oldOverflow || '';if(previousFocus && previousFocus.isConnected)previousFocus.focus();});
  });
  if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
  document.addEventListener('shopify:section:load',initialize);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-product-navigation"] && !Shopify.designMode) return;
  try {
    (() => {
  const SOURCE_KEY = 'pnm_product_sources_v1';
  const RESTORE_KEY = 'pnm_product_return_v1';
  const MAX_AGE = 2 * 60 * 60 * 1000;
  const safeURL = value => {
    try { const url = new URL(value, location.origin); return url.origin === location.origin && /^https?:$/.test(url.protocol) ? url : null; }
    catch (_) { return null; }
  };
  const productHandle = value => safeURL(value)?.pathname.match(/\/products\/([^/]+)/)?.[1] || '';
  const isList = value => { const url = safeURL(value); return !!url && !productHandle(url.href) && /\/(collections\/[^/]+|search)(\/|$)/.test(url.pathname); };
  const urlKey = value => {
    const url = safeURL(value);
    if (!url) return '';
    url.searchParams.delete('preview_theme_id');
    url.searchParams.delete('_fd');
    url.searchParams.delete('pb');
    url.searchParams.sort();
    return url.pathname.replace(/\/$/, '') + url.search;
  };
  const read = key => { try { return JSON.parse(sessionStorage.getItem(key) || 'null'); } catch (_) { return null; } };
  const write = (key, value) => { try { sessionStorage.setItem(key, JSON.stringify(value)); } catch (_) {} };
  const remove = key => { try { sessionStorage.removeItem(key); } catch (_) {} };
  const fresh = record => record && Number.isFinite(record.time) && Date.now() - record.time >= 0 && Date.now() - record.time < MAX_AGE;
  const selection = () => window.PNMBikeSelector?.selection?.() || null;
  const bikeKey = bike => bike ? [bike.brand, bike.model, bike.year || ''].join('|').toLowerCase() : '';
  const bikeLabel = bike => bike ? [bike.year, bike.brand, bike.model].filter(Boolean).join(' ') : '';
  const cardFor = link => link.closest('.product-card') || link;
  let config, button, fallback, activeSource;

  function bikeLink() {
    return document.querySelector('[data-pnm-bike-bar] [data-pnm-bike-parts][href]');
  }
  function isUnfilteredBikeList() {
    const all = safeURL(bikeLink()?.href);
    const here = new URL(location.href);
    if (!all || !selection() || here.pathname !== all.pathname && here.pathname !== all.pathname.split('/').slice(0, 3).join('/')) return false;
    const allowed = new Set(['gff_705339', 'gff_705341', 'gff_705342', 'page', 'sort_by', 'sort', 'preview_theme_id', '_fd', 'pb', 'currency', 'locale']);
    return [...here.searchParams].every(([key, value]) => !value || allowed.has(key) || key.startsWith('utm_'));
  }
  function sourceForProduct() {
    const records = read(SOURCE_KEY);
    if (!Array.isArray(records)) return null;
    const handle = productHandle(location.href);
    return records.find(record => fresh(record) && record.handle === handle && isList(record.source) && urlKey(document.referrer) === urlKey(record.source)) || null;
  }
  function update() {
    if (!config) return;
    const bike = selection();
    const topLink = bikeLink();
    if (bike && topLink) topLink.textContent = config.dataset.allModel.replace('[model]', bike.model);
    if (!button) return;
    activeSource = sourceForProduct();
    if (activeSource && activeSource.bike !== bikeKey(bike)) activeSource = null;
    let href = fallback.href, label = fallback.label, mode = 'browse';
    if (activeSource) {
      href = activeSource.source;
      label = activeSource.namedBike ? config.dataset.backBike.replace('[bike]', activeSource.namedBike) : config.dataset.backResults;
      mode = 'back';
    } else if (bike && topLink && isList(topLink.href)) {
      href = topLink.href;
      label = config.dataset.browseBike.replace('[bike]', bikeLabel(bike));
    }
    button.href = href;
    button.dataset.mode = mode;
    button.querySelector('[data-pnm-return-label]').textContent = label;
  }
  function remember(event) {
    if (event.type === 'auxclick' && event.button !== 1 || !isList(location.href)) return;
    const link = event.target.closest?.('a[href]');
    if (!link || !link.closest('#gf-products, main, #MainContent')) return;
    const handle = productHandle(link.href);
    if (!handle) return;
    const record = {
      handle, source: location.href, time: Date.now(), bike: bikeKey(selection()),
      namedBike: isUnfilteredBikeList() ? bikeLabel(selection()) : '',
      y: window.scrollY, offset: cardFor(link).getBoundingClientRect().top,
      entry: window.navigation?.currentEntry?.key || ''
    };
    const saved = read(SOURCE_KEY);
    const records = Array.isArray(saved) ? saved.filter(item => fresh(item) && item.handle !== handle) : [];
    write(SOURCE_KEY, [record, ...records].slice(0, 8));
  }
  function returnToSource(event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || button.target === '_blank') return;
    update();
    if (!activeSource) return;
    write(RESTORE_KEY, { ...activeSource, time: Date.now(), focus: event.detail === 0 });
    // Traverse only a verified same-origin list entry. New tabs and older browsers use the real href.
    const nav = window.navigation;
    const entry = nav?.entries?.().find(item => item.key === activeSource.entry && item.index < nav.currentEntry.index && urlKey(item.url) === urlKey(activeSource.source));
    if (entry && typeof nav.traverseTo === 'function') {
      event.preventDefault();
      const destination = button.href;
      try { nav.traverseTo(entry.key).finished.catch(() => location.assign(destination)); }
      catch (_) { location.assign(destination); }
    }
  }
  let stopRestoring = () => {};
  function restore() {
    stopRestoring();
    if (!isList(location.href)) return;
    const record = read(RESTORE_KEY);
    if (!fresh(record) || Date.now() - record.time > 60000 || urlKey(record.source) !== urlKey(location.href)) return;
    remove(RESTORE_KEY);
    const target = document.querySelector('#gf-products') || document.querySelector('main');
    if (!target) return;
    let stopped = false, scheduled = false, focused = false;
    const timers = [];
    const stop = () => {
      stopped = true;
      observer.disconnect();
      timers.forEach(clearTimeout);
      ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(name => window.removeEventListener(name, stop));
      window.removeEventListener('globoFilterRenderCompleted', schedule);
      window.removeEventListener('pagehide', stop);
    };
    const position = () => {
      scheduled = false;
      if (stopped || urlKey(record.source) !== urlKey(location.href)) return;
      const link = [...target.querySelectorAll('a[href*="/products/"]')].find(item => productHandle(item.href) === record.handle && item.getClientRects().length);
      if (!link) return;
      const y = window.scrollY + cardFor(link).getBoundingClientRect().top - record.offset;
      if (Number.isFinite(y) && Math.abs(window.scrollY - y) > 3) window.scrollTo({ top: Math.max(0, y), behavior: 'instant' });
      if (record.focus && !focused) { link.focus({ preventScroll: true }); focused = true; }
    };
    const schedule = () => { if (!scheduled && !stopped) { scheduled = true; requestAnimationFrame(position); } };
    const observer = new MutationObserver(schedule);
    observer.observe(target, { childList: true, subtree: true });
    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach(name => window.addEventListener(name, stop, { passive: true }));
    window.addEventListener('globoFilterRenderCompleted', schedule);
    window.addEventListener('pagehide', stop);
    [0, 250, 800, 1800, 4000, 8000].forEach(delay => timers.push(setTimeout(schedule, delay)));
    timers.push(setTimeout(stop, 10000));
    stopRestoring = stop;
  }
  function positionReturnLink() {
    const wrapper = button.closest('.pnm-product-return');
    const details = wrapper?.closest('[data-pnm-product]')?.querySelector('[data-pnm-details]');
    if (!wrapper || !details) return;
    const desktopParent = wrapper.parentNode;
    const desktopNext = wrapper.nextSibling;
    const mobile = window.matchMedia('(max-width: 991px)');
    const position = () => {
      if (mobile.matches) {
        if (details.nextElementSibling !== wrapper) details.after(wrapper);
      } else if (wrapper.parentNode !== desktopParent) {
        desktopParent.insertBefore(wrapper, desktopNext?.parentNode === desktopParent ? desktopNext : null);
      }
    };
    mobile.addEventListener('change', position);
    position();
  }
  function init() {
    config = document.querySelector('[data-pnm-navigation]');
    if (!config) return;
    button = document.querySelector('[data-pnm-product-return]');
    if (button) {
      fallback = { href: button.href, label: button.querySelector('[data-pnm-return-label]').textContent };
      button.addEventListener('click', returnToSource);
      positionReturnLink();
    }
    document.addEventListener('click', remember, true);
    document.addEventListener('auxclick', remember, true);
    window.addEventListener('pnm:bike-change', update);
    window.addEventListener('pageshow', event => { update(); if (event.persisted) restore(); });
    update();
    restore();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-readable-type"] && !Shopify.designMode) return;
  try {
    (() => {
  const cartCss = `
    .upcart-product-title, .upcart-product-title-link, .upcart-upsell-item-title { font-size:18px!important; line-height:1.4!important; }
    .upcart-item-price, .upcart-product-quantity-input, .upcart-upsell-item-price-row, .upcart-upsell-item-price { font-size:18px!important; line-height:1.35!important; }
    .upcart-announcement, .upcart-announcement p, .upcart-rewards-message, .upcart-rewards-message p { font-size:18px!important; line-height:1.4!important; }
    .upcart-rewards-tier-description { font-size:14px!important; line-height:1.35!important; }
    .upcart-rewards-tier:last-child .upcart-rewards-tier-description { width:110px; text-align:right; align-self:flex-end; }
    .upcart-upsells-title, .upcart-upsells-title p { font-size:18px!important; line-height:1.4!important; }
    .upcart-upsells-button { font-size:18px!important; line-height:1.3!important; min-height:44px!important; }
    .upcart-continue-shopping, .upcart-continue-shopping a { font-size:18px!important; line-height:1.4!important; }
    .upcart-checkout-button { font-size:18px!important; line-height:1.4!important; min-height:48px!important; }
  `;
  function applyCartType() {
    const root = document.getElementById('upCart')?.shadowRoot;
    if (!root) return false;
    if (!root.querySelector('[data-pnm-readable-cart]')) {
      const style = document.createElement('style');
      style.setAttribute('data-pnm-readable-cart', '');
      style.textContent = cartCss;
      root.appendChild(style);
    }
    return true;
  }
  if (applyCartType()) return;
  const observer = new MutationObserver(() => {
    if (applyCartType()) observer.disconnect();
  });
  observer.observe(document.documentElement, { childList:true, subtree:true });
  window.addEventListener('pagehide', () => observer.disconnect(), { once:true });
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-results-toolbar"] && !Shopify.designMode) return;
  try {
    (() => {
  const configNode = document.querySelector('[data-pnm-results-toolbar-config]');
  if (!configNode) return;
  const config = JSON.parse(configNode.textContent);
  const overview = document.querySelector('[data-pnm-collection-overview]');
  const overviewHome = overview ? document.createComment('Collection heading fallback') : null;
  if (overviewHome) overview.before(overviewHome);
  const selector = '.gf-controls-search-form,.gf-summary,.gf-filter-selection';
  let scheduled = false;
  const markPath = (node, root) => {
    for (let parent = node.parentElement; parent && parent !== root; parent = parent.parentElement) {
      if (parent.classList.contains('pnm-toolbar-footer')) continue;
      parent.classList.add('pnm-results-toolbar__pass');
    }
  };
  function searchScope() {
    const params = new URLSearchParams(location.search);
    const api = window.PNMCollectionYear;
    const context = api?.context();
    const base = location.pathname.match(/\/collections\/[^/]+/)?.[0] || '';
    const universal = location.pathname.slice(base.length + 1).split('+').some(tag => tag.toLowerCase() === 'universal');
    let categories = [];
    try { categories = JSON.parse(document.querySelector('[data-pnm-universal-config]')?.textContent || '{}').categories?.filter(Boolean) || []; } catch (_) {}
    const direct = categories.find(item => item.handle === config.collectionHandle);
    const selectedCategories = params.getAll('gf_852978');
    const selectedCategory = selectedCategories.length === 1 ? categories.find(item => !item.parent && item.label === selectedCategories[0]) : null;
    const category = direct && (!selectedCategory || direct.parent === selectedCategory.label || direct.handle === selectedCategory.handle) ? direct : selectedCategory;
    const format = (pattern, values) => pattern.replace(/\[(bike|category|collection)\]/g, (_, key) => values[key] || '');
    if (universal) {
      const label = category ? format(config.universalCategorySearch, {category:category.label}) : config.universalSearch;
      return {label, placeholder:label + '…'};
    }
    let bike = window.PNMBikeBrowse?.context()?.bike || context?.bike;
    const options = [...(document.getElementById('pnm-bike-options')?.content.querySelectorAll('option') || [])];
    if (!context && api && params.getAll('gff_705341').length === 1 && params.getAll('gff_705339').length === 1) {
      const model = params.get('gff_705341');
      const brand = params.get('gff_705339');
      for (const option of options) {
        if (option.dataset.brand !== brand || !option.value.startsWith('/collections/')) continue;
        const candidate = api.context(option.value, params)?.bike;
        if (candidate?.brand === brand && candidate.modelType === model) { bike = candidate; break; }
      }
    }
    let model = bike?.modelDisplay || bike?.modelType;
    if (!model && context && options.some(option => option.value === context.base)) {
      const brand = context.models[0]?.brand;
      model = brand && context.label.startsWith(brand + ' ') ? context.label.slice(brand.length + 1) : context.label;
    }
    if (model) {
      const bikeLabel = [bike?.bikeYear, model].filter(Boolean).join(' ');
      const label = category ? format(config.categoryBikeSearch, {category:category.label, bike:bikeLabel}) : format(config.bikeSearch, {bike:bikeLabel});
      const accessibleBike = [bike?.bikeYear, bike?.brand, model].filter(Boolean).join(' ');
      const accessibleLabel = category ? format(config.categoryBikeSearch, {category:category.label, bike:accessibleBike}) : format(config.bikeSearch, {bike:accessibleBike});
      return {label:accessibleLabel, placeholder:label + '…'};
    }
    const title = category?.label || config.collectionTitle;
    const label = title ? format(config.collectionSearch, {collection:title}) : config.label;
    return {label, placeholder:title ? label + '…' : config.placeholder};
  }
  function currentResultsBike() {
    const browse = window.PNMBikeBrowse?.context();
    if (browse?.scoped && browse.bike?.bikeYear) return browse.bike;
    const context = window.PNMCollectionYear?.context();
    const bike = context?.bike;
    if (!bike?.bikeYear || ![bike.target, bike.baseURL].includes(context.base)) return null;
    const tags = location.pathname.slice(context.base.length + 1).split('+');
    if (tags.some(tag => tag.toLowerCase() === 'universal')) return null;
    return bike;
  }
  const mobileLayout = window.matchMedia('(max-width:767px)');
  function syncMobileToolbar(actions,bike) {
    const nav = document.querySelector('[data-pnm-main-categories]');
    if (!nav) return;
    let header = actions.querySelector('.pnm-mobile-toolbar-heading');
    if (!header) {
      header = document.createElement('div');
      header.className = 'pnm-mobile-toolbar-heading';
      const title = document.createElement('strong');
      const change = document.createElement('button');
      change.type = 'button';
      change.textContent = config.mobileChange;
      change.setAttribute('aria-label',config.changeModelYear);
      change.setAttribute('aria-haspopup','dialog');
      change.setAttribute('aria-controls','pnm-model-dialog');
      change.addEventListener('click',() => window.PNMBikeSelector?.open(change));
      header.append(title,change);
      actions.prepend(header);
    }
    const title = bike ? [bike.bikeYear,bike.brand,bike.modelDisplay || bike.modelType].filter(Boolean).join(' ') : overview?.querySelector('h2')?.textContent || config.collectionTitle;
    if (header.firstElementChild.textContent !== title) header.firstElementChild.textContent = title;
    header.querySelector('button').hidden = !bike;
    let category = actions.querySelector('.pnm-mobile-toolbar-category');
    if (!category) {
      category = document.createElement('div');
      category.className = 'pnm-mobile-toolbar-category';
      const select = document.createElement('select');
      select.setAttribute('aria-label',nav.dataset.categoryLabel);
      select.addEventListener('change',() => {
        const link = select.value ? [...nav.querySelectorAll('a[data-category]')].find(item => item.dataset.category === select.value) : nav.querySelector('[data-pnm-browse-all]');
        if (link) link.click();
        select.value = nav.querySelector('a[data-category][aria-current="page"]')?.dataset.category || '';
      });
      select.id = 'pnm-mobile-category-select';
      const categoryLabel = document.createElement('label');
      categoryLabel.htmlFor = select.id;
      categoryLabel.textContent = config.mobileCategory;
      category.append(categoryLabel,select);
      actions.append(category);
    }
    const links = [...nav.querySelectorAll('a[data-category]')].filter(link => link.dataset.empty !== 'true' && link.dataset.pnmMobileCount !== '0');
    const options = [{value:'',label:nav.dataset.allLabel},...links.map(link => ({value:link.dataset.category,label:link.querySelector('.pnm-main-categories__name').textContent + (link.dataset.pnmMobileCount ? ' (' + link.dataset.pnmMobileCount + ')' : '')}))];
    const signature = JSON.stringify(options);
    if (category.dataset.options !== signature) {
      category.querySelector('select').replaceChildren(...options.map(option => new Option(option.label,option.value)));
      category.dataset.options = signature;
    }
    const selectedCategory = nav.querySelector('a[data-category][aria-current="page"]')?.dataset.category || '';
    category.querySelector('select').value = options.some(option => option.value === selectedCategory) ? selectedCategory : '';
    const partHeading = actions.querySelector('.pnm-part-type__heading');
    if (partHeading && !partHeading.querySelector('.pnm-mobile-part-label')) {
      const partLabel = document.createElement('span');
      partLabel.className = 'pnm-mobile-part-label';
      partLabel.textContent = config.mobilePartType;
      partHeading.append(partLabel);
    }
    actions.classList.add('pnm-mobile-unified');
    document.body.classList.add('pnm-has-mobile-toolbar');
  }

  function sync() {
    scheduled = false;
    const bike = currentResultsBike();
    const scope = searchScope();
    let overviewPlaced = false;
    document.querySelectorAll('.page-collections .gf-controls-search-form').forEach(search => {
      const page = search.closest('.page-content') || search.closest('.page-collections');
      const summary = page?.querySelector('.gf-summary');
      const selection = page?.querySelector('.gf-filter-selection');
      const actions = summary?.closest('.gf-actions');
      const input = search.querySelector('input:not([type="hidden"]):not([type="submit"]):not([type="button"])');
      if (!input) return;
      if (!input.dataset.pnmSearchInitialized) {
        const savedQuery = new URLSearchParams(location.search).get(input.name || 'q') || '';
        if (!input.value && savedQuery) { input.value = savedQuery; input.defaultValue = savedQuery; }
        input.dataset.pnmSearchInitialized = 'true';
      }
      const placeholder = mobileLayout.matches ? config.mobilePlaceholder : config.namedSearch;
      if (input.placeholder !== placeholder) input.placeholder = placeholder;
      let hint = search.querySelector('.pnm-search-oem-hint');
      if (!hint) {
        hint = document.createElement('p');
        hint.className = 'pnm-search-oem-hint';
        hint.id = (input.id || 'pnm-parts-search') + '-oem-hint';
        hint.textContent = config.oemHint;
        search.append(hint);
      }
      const described = new Set((input.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean));
      described.add(hint.id);
      input.setAttribute('aria-describedby',[...described].join(' '));
      const accessibleLabel = scope.label + '. ' + config.namedSearch.replace('…','');
      if (input.getAttribute('aria-label') !== accessibleLabel) input.setAttribute('aria-label', accessibleLabel);
      let searchLabel = search.querySelector('label[for="' + input.id + '"]');
      if (!searchLabel) { searchLabel = document.createElement('label'); searchLabel.htmlFor = input.id; search.prepend(searchLabel); }
      searchLabel.classList.remove('sr-only','visually-hidden');
      searchLabel.classList.add('pnm-search-label');
      const visibleLabel = bike ? config.searchBikeLabel : scope.label;
      if (searchLabel.textContent !== visibleLabel) searchLabel.textContent = visibleLabel;
      let field = search.querySelector('.pnm-search-field');
      if (!field) { field = document.createElement('div'); field.className = 'pnm-search-field'; input.before(field); field.append(input); }
      let button = search.querySelector('[data-pnm-search-submit]');
      if (!button) { button = document.createElement('button'); button.type = 'submit'; button.dataset.pnmSearchSubmit = ''; button.textContent = config.submit; field.append(button); }
      let searchActions = search.querySelector('.pnm-search-actions');
      if (!searchActions) {
        searchActions = document.createElement('div'); searchActions.className = 'pnm-search-actions';
        const clear = actions?.querySelector('[data-pnm-clear-search]') || document.createElement('a'); clear.dataset.pnmClearSearch = ''; clear.textContent = config.clearSearch;
        const help = actions?.querySelector('[data-pnm-shopping-help]') || document.createElement('a'); help.dataset.pnmShoppingHelp = ''; help.textContent = config.help;
        searchActions.append(clear,help); search.append(searchActions);
      }
      const clear = searchActions.querySelector('[data-pnm-clear-search]') || actions?.querySelector('[data-pnm-clear-search]');
      clear.hidden = !input.value.trim();
      clear.href = window.PNMEasyShopping?.clearSearchURL() || location.pathname;
      const help = searchActions.querySelector('[data-pnm-shopping-help]') || actions?.querySelector('[data-pnm-shopping-help]');
      const helpLabel = mobileLayout.matches ? config.help : config.desktopHelp;
      if (help.textContent !== helpLabel) help.textContent = helpLabel;
      help.href = window.PNMEasyShopping?.contactURL() || '/pages/contact';
      input.setAttribute('enterkeyhint', 'search');
      search.querySelectorAll('svg,i').forEach(icon => {
        if (!icon.closest('button,a,[role="button"]')) icon.classList.add('pnm-search-decoration');
      });
      const submit = [...search.querySelectorAll('button,input[type="submit"]')].find(button => {
        const name = [button.className, button.getAttribute('aria-label'), button.textContent].join(' ');
        return button.type !== 'reset' && !/clear|reset/i.test(name);
      });
      if (submit) {
        submit.classList.add('pnm-search-submit');
        submit.classList.toggle('pnm-search-submit-text', Boolean(submit.textContent.trim()));
        search.classList.add('pnm-search-has-submit');
        if (!submit.getAttribute('aria-label') && !submit.textContent.trim()) submit.setAttribute('aria-label', config.submit);
      }
      if (!actions || !selection || !actions.contains(selection) || search.contains(actions)) return;
      const count = summary.closest('.gf-filter-trigger') || summary;
      if (!actions.contains(count)) return;
      if (!actions.contains(search)) actions.prepend(search);
      actions.classList.add('pnm-results-toolbar','pnm-toolbar-dark','pnm-desktop-simple');
      const resultCount = Number(summary.textContent.replace(/[^0-9]/g,''));
      actions.dataset.smallResults = String(Number.isFinite(resultCount) && resultCount <= 24);
      syncMobileToolbar(actions,bike);
      button.setAttribute('aria-label',config.submit);
      if (overview && !overviewPlaced && overviewHome.parentElement?.contains(page)) {
        // Move the original nodes so bike updates and review handlers stay intact.
        if (overview.parentElement !== actions) actions.prepend(overview);
        overview.classList.add('pnm-search-heading');
        overviewPlaced = true;
      }
      actions.classList.toggle('pnm-toolbar-native-sort', Boolean(selection.querySelector('.sort-by-toggle')));
      count.classList.add('pnm-results-toolbar__count');
      markPath(search, actions);
      markPath(count, actions);
      markPath(selection, actions);
      let footer = actions.querySelector('.pnm-toolbar-footer');
      if (!footer) {
        footer = document.createElement('div');
        footer.className = 'pnm-toolbar-footer';
        actions.append(footer);
      }
      [summary,help,clear,selection].forEach(node => {
        if (node.parentElement !== footer) footer.append(node);
      });
    });
    if (overview && !overviewPlaced && overviewHome.isConnected) {
      overview.classList.remove('pnm-search-heading');
      if (overview.previousSibling !== overviewHome) overviewHome.after(overview);
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  function start() {
    sync();
    const page = document.querySelector('.page-collections');
    if (!page) return;
    new MutationObserver(records => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(selector) || node.querySelector(selector))))) schedule();
    }).observe(page, {childList:true, subtree:true});
    const categoryNav = document.querySelector('[data-pnm-main-categories]');
    if (categoryNav) new MutationObserver(schedule).observe(categoryNav,{subtree:true,childList:true,attributes:true,attributeFilter:['aria-current','data-pnm-mobile-count','data-empty','data-has-bike']});
    page.addEventListener('change', schedule);
    page.addEventListener('input',event => { if (event.target.matches('.gf-controls-search-input')) schedule(); });
  }
  mobileLayout.addEventListener('change',schedule);
  window.addEventListener('pnm:part-type-ready', schedule);
  window.addEventListener('pnm:browse-ready', schedule);
  window.addEventListener('pnm:bike-change', schedule);
  window.addEventListener('pageshow', schedule);
  window.addEventListener('globoFilterRenderCompleted', schedule);
  window.addEventListener('popstate', schedule);
  document.addEventListener('shopify:section:load', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-search-experience"] && !Shopify.designMode) return;
  try {
    (() => {
  const root=document.querySelector('[data-pnm-search]'),config=document.querySelector('[data-pnm-search-config]');
  if(!root||!config||root.dataset.ready)return;
  root.dataset.ready='true';
  const {labels:L,url:searchURL,stock:stockLabels}=JSON.parse(config.textContent);
  const find=s=>root.querySelector(s),normal=s=>String(s||'').toLowerCase().replace(/[^a-z0-9]/g,''),quote=s=>'"'+String(s).replace(/["\\]/g,' ')+'"';
  const params=new URLSearchParams(location.search),query=(params.get('q')||'').trim();
  const input=find('[name=q]'),sort=find('[data-search-sort]');
  const text=(key,values={})=>Object.entries(values).reduce((s,[k,v])=>s.replace('__'+k+'__',v),L[key]);
  let controller,run=0,groups={primary:[],related:[]},shown={primary:24,related:12},activeBike=null,fallback=false;
  const tokens=query.toLowerCase().match(/[a-z0-9-]+/g)?.filter(t=>!['a','an','the','and','or','for','my','i','need','oem','number','part','parts'].includes(t))||[];
  const aliases={carbs:'carb',carburetor:'carb',carburetors:'carb',carburettor:'carb',carburettors:'carb',kits:'kit',seals:'seal',brakes:'brake',filters:'filter',gaskets:'gasket',bearings:'bearing',plugs:'plug',cables:'cable'};
  const words=tokens.map(t=>aliases[t]||t);
  const carbKit=words.includes('carb')&&words.includes('kit');
  const tools=/\b(tool|tools|cleaner|cleaning|synchronizer|synchroniser|gauge|gauges)\b/i.test(query);
  const universal=p=>p.tags.some(t=>/^universal(?:\/custom)?$/i.test(t));
  const tool=p=>/\b(tool|tools|synchroni[sz]er|cleaner|cleaning|gauge|gauges|shop kit)\b/i.test(p.title);
  function bike(){
    const link=document.querySelector('[data-pnm-bike-parts]:not([hidden])');
    if(link?.getAttribute('href')){const u=new URL(link.href,location.origin),m=u.searchParams.get('gff_705341'),b=(u.searchParams.get('gff_705339')||'').split(',')[0].replace(/ - ATV$/,'');if(b&&m)return {brand:b,model:m,year:u.searchParams.get('gff_705342')||''}}
    const selected=window.PNMBikeSelector?.selection();
    if(selected?.model)return selected;
    const brand=(params.get('gff_705339')||'').split(',')[0].replace(/ - ATV$/,'');
    return brand&&params.get('gff_705341')?{brand,model:params.get('gff_705341'),year:params.get('gff_705342')||''}:null;
  }
  function fits(p,b){
    if(!b)return true;
    const brand=p.tags.some(t=>t.replace(/ - ATV$/,'')===b.brand);
    return brand&&(b.year?p.tags.includes(b.model+' ('+b.year+')'):p.tags.some(t=>t===b.model||t.startsWith(b.model+' (')));
  }
  function destination(all=false,newBike=null){
    const target=new URL(searchURL,location.origin);target.searchParams.set('q',input.value.trim()||query);target.searchParams.set('type','product');
    if(all)target.searchParams.set('pnm_search_scope','all');
    const b=newBike||bike();if(b){target.searchParams.set('gff_705339',b.brand);target.searchParams.set('gff_705341',b.model);if(b.year)target.searchParams.set('gff_705342',b.year)}
    if(params.has('preview_theme_id'))target.searchParams.set('preview_theme_id',params.get('preview_theme_id'));
    return target.href;
  }
  function syncScope(){
    const saved=bike();activeBike=params.get('pnm_search_scope')==='all'?null:saved;
    const name=activeBike?[activeBike.year,activeBike.brand,activeBike.model].filter(Boolean).join(' '):'';
    find('[data-search-scope]').textContent=activeBike?text('bike_scope',{bike:name}):L.all_bikes;
    find('[data-search-hint]').hidden=!!activeBike;find('[data-search-hint]').textContent=saved?L.all_bikes:L.no_bike;
    find('[data-search-bike]').textContent=saved?L.change:L.choose;
    find('[data-search-all]').hidden=!activeBike;find('[data-search-all]').href=destination(true);
    find('[data-search-selected]').hidden=!saved||!!activeBike;find('[data-search-selected]').href=destination(false);
    find('[data-search-heading]').textContent=query?text('title',{query}):L.browse;
  }
  function score(p){
    const title=normal(p.title),code=normal(query);let value=0;
    if(code&&p.skus.some(s=>normal(s)===code))value+=100000;
    if(code&&title.includes(code))value+=2000;
    words.forEach(w=>{if(title.includes(normal(w)))value+=100});
    if(carbKit&&/carb/i.test(p.title)&&/\bkit\b/i.test(p.title)){value+=500;if(/rebuild|repair/i.test(p.title))value+=1000}
    if(!tools&&tool(p))value-=1500;
    if(p.stock!=='sold_out')value+=10;
    return value;
  }
  function card(p){
    const template=document.createElement('template');template.innerHTML=p.html;
    const node=template.content.querySelector('.product-card');if(!node)return null;
    node.setAttribute('data-pnm-card-status','');node.setAttribute('data-pnm-fit-tags',p.tags.join('||'));
    const badge=document.createElement('div');badge.className='pnm-card-fitment';badge.setAttribute('data-pnm-card-fitment','');badge.hidden=true;
    const content=node.querySelector('.product-content');content?.insertBefore(badge,content.querySelector('.product-price'));
    if(stockLabels[p.stock]){const label=document.createElement('span');label.className='pnm-card-stock';label.setAttribute('data-pnm-stock',p.stock);label.textContent='• '+stockLabels[p.stock];node.querySelector('.product-image')?.prepend(label)}
    const b=bike();if(b)node.querySelectorAll('a[href*="/products/"]').forEach(a=>{const url=new URL(a.href,location.origin);url.searchParams.set('gff_705339',b.brand);url.searchParams.set('gff_705341',b.model);if(b.year)url.searchParams.set('gff_705342',b.year);a.href=url.href});
    const item=document.createElement('div');item.className='halo-item';item.append(node);return item;
  }
  function renderGroup(key){
    const grid=find('[data-search-'+key+'-grid]');grid.replaceChildren();
    groups[key].slice(0,shown[key]).forEach(p=>{const item=card(p);if(item)grid.append(item)});
    find('[data-search-'+key+']').hidden=!groups[key].length;
    find('[data-search-more="'+key+'"]').hidden=shown[key]>=groups[key].length;
  }
  function order(){
    const sorter=sort.value==='price-ascending'?(a,b)=>a.price-b.price:sort.value==='price-descending'?(a,b)=>b.price-a.price:sort.value==='title-ascending'?(a,b)=>a.title.localeCompare(b.title):(a,b)=>score(b)-score(a);
    Object.values(groups).forEach(list=>list.sort((a,b)=>sorter(a,b)||a.title.localeCompare(b.title)));
    renderGroup('primary');renderGroup('related');
  }
  async function getPage(term,page,signal){
    const url=new URL(searchURL,location.origin);url.searchParams.set('type','product');url.searchParams.set('q',term);url.searchParams.set('view','pnm-ranked-data');url.searchParams.set('page',String(page));url.searchParams.set('options[unavailable_products]','show');
    if(params.has('preview_theme_id'))url.searchParams.set('preview_theme_id',params.get('preview_theme_id'));
    const response=await fetch(url,{signal,credentials:'same-origin'});if(!response.ok)throw Error('search');
    const data=await response.json();if(!Array.isArray(data.products)||!Number.isInteger(data.pages))throw Error('search');return data;
  }
  async function allPages(term,signal){
    const first=await getPage(term,1,signal),products=[...first.products];
    for(let page=2;page<=first.pages;page+=3){const pages=await Promise.all(Array.from({length:Math.min(3,first.pages-page+1)},(_,i)=>getPage(term,page+i,signal)));pages.forEach(p=>products.push(...p.products))}
    if(products.length!==first.count)throw Error('incomplete');return products;
  }
  async function load(){
    const id=++run;controller?.abort();controller=new AbortController();syncScope();
    find('[data-search-empty]').hidden=true;find('[data-search-retry]').hidden=true;
    if(!query||!words.length){find('[data-search-status]').textContent=L.enter;return}
    groups={primary:[],related:[]};find('[data-search-primary]').hidden=true;find('[data-search-related]').hidden=true;
    root.setAttribute('aria-busy','true');find('[data-search-status]').textContent=L.loading;
    try{
      const titleQuery=words.map(w=>'title:'+quote(w+'*')).join(' AND ');
      const numeric=/\d/.test(query);const main=numeric?'('+titleQuery+' OR variants.sku:'+quote(query)+' OR body:'+quote(query)+')':titleQuery;
      const b=activeBike;
      const scope=b?' AND ((tag:'+quote(b.brand)+' AND tag:'+quote(b.year?b.model+' ('+b.year+')':b.model)+') OR tag:Universal OR tag:"Universal/Custom")':'';
      let products=await allPages('('+main+')'+scope,controller.signal);fallback=false;
      if(!products.length){products=await allPages(query+scope,controller.signal);fallback=products.length>0}
      if(carbKit){const extra=await allPages('title:carb* AND (title:tool* OR title:clean* OR title:synchron* OR title:gauge*) AND (tag:Universal OR tag:"Universal/Custom")',controller.signal);products.push(...extra)}
      if(id!==run)return;
      const unique=[...new Map(products.map(p=>[p.id,p])).values()].filter(p=>!b||fits(p,b)||universal(p));
      groups={primary:[],related:[]};unique.forEach(p=>groups[(b&&universal(p))||(!tools&&tool(p)&&!p.skus.some(s=>normal(s)===normal(query)))?'related':'primary'].push(p));
      const name=b?[b.year,b.brand,b.model].filter(Boolean).join(' '):'';
      find('[data-search-primary] h2').textContent=fallback?L.other_matches:b?text('bike_scope',{bike:name}):L.primary;
      find('[data-search-status]').textContent=(unique.length===1?L.count_one:text('count',{count:unique.length}))+(fallback?' · '+L.fallback_note:'')+(unique.length>=1000?' · '+L.narrow:'');
      find('[data-search-empty]').hidden=groups.primary.length>0;
      find('[data-search-empty-title]').textContent=b?text('no_bike_matches',{bike:name}):L.no_matches;
      shown={primary:24,related:12};order();
    }catch(error){if(error.name!=='AbortError'&&id===run){find('[data-search-status]').textContent=L.error;find('[data-search-empty]').hidden=false;find('[data-search-empty-title]').textContent=L.error;find('[data-search-retry]').hidden=false}}
    finally{if(id===run)root.removeAttribute('aria-busy')}
  }
  const selectedSort=params.get('sort_by');if([...sort.options].some(o=>o.value===selectedSort))sort.value=selectedSort;
  sort.addEventListener('change',()=>{order();const url=new URL(location.href);url.searchParams.set('sort_by',sort.value);history.replaceState(history.state,'',url.href)});
  find('[data-search-form]').addEventListener('submit',event=>{event.preventDefault();event.stopPropagation();location.assign(destination(params.get('pnm_search_scope')==='all'))});
  find('[data-search-bike]').addEventListener('click',event=>{
    const selector=window.PNMBikeSelector;if(!selector?.check)return;
    selector.check(event.currentTarget,b=>location.assign(destination(false,{brand:b.brand,model:b.modelType,year:b.bikeYear})));
    const dialog=document.querySelector('#pnm-model-dialog');if(dialog){const heading=dialog.querySelector('h2');if(heading)heading.textContent=L.choose;const intro=dialog.querySelector('p');if(intro)intro.textContent=L.select_intro;const submit=dialog.querySelector('button[type=submit]');if(submit)submit.textContent=L.search_bike}
  });
  find('[data-search-retry]').addEventListener('click',load);
  root.querySelectorAll('[data-search-more]').forEach(button=>button.addEventListener('click',()=>{const key=button.dataset.searchMore,grid=find('[data-search-'+key+'-grid]'),start=shown[key];shown[key]+=24;groups[key].slice(start,shown[key]).forEach(p=>{const item=card(p);if(item)grid.append(item)});button.hidden=shown[key]>=groups[key].length}));
  let signature='';
  const bikeSignature=()=>JSON.stringify(bike());
  function watchBike(){const key=bikeSignature();if(key!==signature){signature=key;load()}}
  const bar=document.querySelector('[data-pnm-bike-bar]');if(bar)new MutationObserver(()=>watchBike()).observe(bar,{subtree:true,childList:true,attributes:true,attributeFilter:['href','hidden']});
  window.addEventListener('pnm:bike-change',()=>setTimeout(watchBike,0));
  window.addEventListener('storage',()=>setTimeout(watchBike,100));
  function start(attempt=0){if(!window.PNMBikeSelector&&attempt<100){setTimeout(()=>start(attempt+1),30);return}signature=bikeSignature();load()}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>start(),{once:true});else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-universal-category"] && !Shopify.designMode) return;
  try {
    (() => {
  const node = document.querySelector('[data-pnm-universal-config]');
  const template = document.querySelector('[data-pnm-universal-template]');
  if (!node || !template) return;
  const config = JSON.parse(node.textContent);
  const categories = config.categories.filter(Boolean);
  const panel = template.content.firstElementChild.cloneNode(true);
  const heading = panel.querySelector('h2');
  const categoryLabel = panel.querySelector('.pnm-universal__label');
  const note = panel.querySelector('p');
  const link = panel.querySelector('a');
  const caption = link.querySelector('span');
  const returnPanel = document.createElement('div');
  returnPanel.className = 'pnm-universal-return';
  returnPanel.hidden = true;
  const returnLink = link.cloneNode(true);
  const returnCaption = returnLink.querySelector('span');
  returnPanel.append(returnLink);
  const returnKey = 'pnm_universal_return_v1';
  const available = new Map();
  let scheduled = false, currentContext = null, settling;
  const pageNumber = url => Number(url.searchParams.get('page') || url.searchParams.get('gf_page') || 1);
  const relative = url => url.pathname + url.search;
  const bikeKey = url => ['gff_705339','gff_705341','gff_705342'].map(key => { const value = url.searchParams.get(key) || ''; if (key !== 'gff_705339') return value; const brands = value.split(',').map(item => item.trim().replace(/ - ATV$/,'')); return brands.every(item => item === brands[0]) ? brands[0] : ''; }).join('|');
  function safeURL(value) {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /\/collections\/[^/]+/.test(url.pathname) ? url : null;
    } catch (_) { return null; }
  }
  function preview(url) {
    const id = new URL(location.href).searchParams.get('preview_theme_id');
    if (id) url.searchParams.set('preview_theme_id', id);
    return url;
  }
  function categoryFor(url) {
    const values = url.searchParams.getAll('gf_852978');
    if (values.length > 1) return null;
    const direct = categories.find(category => category.handle === config.handle);
    if (values.length === 1) {
      const selected = categories.find(category => !category.parent && category.label === values[0]);
      if (!selected) return null;
      return direct && (direct.parent === selected.label || direct.handle === selected.handle) ? direct : selected;
    }
    return direct || null;
  }
  function selectedBike() {
    const partsLink = [...document.querySelectorAll('[data-pnm-bike-parts]')].find(item => !item.hidden && item.getAttribute('href'));
    const url = partsLink && safeURL(partsLink.getAttribute('href'));
    if (!url?.searchParams.get('gff_705339') || !url.searchParams.get('gff_705341')) return null;
    const brand = url.searchParams.get('gff_705339');
    const model = url.searchParams.get('gff_705341');
    const year = url.searchParams.get('gff_705342');
    return {url, key:bikeKey(url), label:brand.split(',')[0].replace(/ - ATV$/,'') + ' ' + model + (year ? ' (' + year + ')' : '')};
  }
  function destination(category) {
    return preview(new URL(config.root.replace(/\/$/, '') + '/collections/' + category.handle + '/universal', location.origin));
  }
  function hasItems(category) {
    const cached = available.get(category.handle);
    if (cached !== undefined) return cached;
    available.set(category.handle, null);
    const url = destination(category);
    url.searchParams.set('view', 'pnm-universal-count');
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    fetch(relative(url), {credentials:'same-origin', signal:controller.signal})
      .then(response => { if (!response.ok) throw new Error('Unavailable'); return response.json(); })
      .then(data => available.set(category.handle, data.universal === true && data.handle === category.handle && Number(data.count) > 0))
      .catch(() => available.set(category.handle, false))
      .finally(() => { clearTimeout(timeout); schedule(); });
    return null;
  }
  const visible = element => Boolean(element && element.getClientRects().length && getComputedStyle(element).visibility !== 'hidden');
  function finalResults(grid, page) {
    if (grid.getAttribute('aria-busy') === 'true') return false;
    const summary = page.querySelector('.gf-summary');
    if (!summary) return false;
    const numbers = (summary.textContent.match(/\d[\d,]*/g) || []).map(value => Number(value.replace(/,/g, '')));
    const total = numbers.at(-1);
    if (!Number.isFinite(total)) return false;
    const count = grid.querySelectorAll('[data-pnm-card-status]').length;
    const current = pageNumber(new URL(location.href));
    // Any visible forward page link takes precedence over counts during a re-render.
    const forward = [...page.querySelectorAll('a[href]')].some(anchor => {
      if (!visible(anchor) || grid.contains(anchor) || panel.contains(anchor)) return false;
      const url = safeURL(anchor.getAttribute('href'));
      return url && url.pathname === location.pathname && pageNumber(url) > current;
    });
    if (forward) return false;
    if (count === total) return true;
    // Numbered pagination: use the app's selected page size or explicit summary range.
    if (numbers.length >= 3 && numbers.at(-2) >= total && count > 0) return true;
    const size = Number(page.querySelector('.limit-by select')?.value);
    return Number.isInteger(current) && current > 1 && size > 0 && count > 0 && count <= size && (current - 1) * size + count >= total;
  }
  function returnURL(bike, category) {
    try {
      const saved = JSON.parse(sessionStorage.getItem(returnKey) || 'null');
      const url = saved && safeURL(saved.url);
      if (url && saved.bike === bike.key && saved.category === category.handle && bikeKey(url) === bike.key) return preview(url);
    } catch (_) { /* Storage can be disabled. The selected bike remains a valid fallback. */ }
    const url = new URL(bike.url);
    url.searchParams.set('gf_852978', category.parent || category.label);
    return preview(url);
  }
  function setText(element, text) { if (element.textContent !== text) element.textContent = text; }
  function sync() {
    scheduled = false;
    const page = document.querySelector('.page-collections .page-content');
    const grid = page?.querySelector('#gf-products');
    const url = new URL(location.href);
    const category = categoryFor(url);
    const bike = selectedBike();
    currentContext = null;
    returnPanel.hidden = true;
    if (!page || !grid || !category) { panel.hidden = true; return; }
    const label = category.label.toLowerCase();
    if (config.universal) {
      panel.classList.add('pnm-universal--browsing');
      setText(heading, config.text.browse.replace('[category]', label));
      setText(note, config.text.note);
      if (bike) {
        setText(caption, config.text.back.replace('[bike]', bike.label));
        link.href = relative(returnURL(bike, category));
        setText(returnCaption, caption.textContent);
        returnLink.href = link.href;
        if (page.lastElementChild !== returnPanel) page.append(returnPanel);
        returnPanel.hidden = false;
      }
      link.hidden = !bike;
      const toolbar = page.querySelector('.gf-actions') || grid;
      if (toolbar.previousElementSibling !== panel) toolbar.before(panel);
      panel.hidden = false;
      return;
    }
    // An actual model filter must be active, not just a previously saved bike.
    if (!bike || !url.searchParams.get('gff_705341') || bikeKey(url) !== bike.key) { panel.hidden = true; return; }
    if (!grid.querySelector('[data-pnm-card-status]')) { panel.hidden = true; return; }
    if (hasItems(category) !== true) { panel.hidden = true; return; }
    if (!finalResults(grid,page)) { panel.hidden = true; return; }
    setText(heading, config.text.heading);
    setText(categoryLabel, config.text.label.replace('[category]', category.label));
    setText(note, config.text.moreNote);
    setText(caption, config.text.button.replace('[category]', label));
    link.href = relative(destination(category));
    link.hidden = false;
    currentContext = {url:relative(url), bike:bike.key, category:category.handle};
    if (grid.nextElementSibling !== panel) grid.after(panel);
    panel.hidden = false;
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(sync);
  }
  function settle() {
    panel.hidden = true;
    returnPanel.hidden = true;
    clearTimeout(settling);
    settling = setTimeout(schedule, 250);
  }
  ['click','auxclick'].forEach(type => link.addEventListener(type, () => {
    if (currentContext) try { sessionStorage.setItem(returnKey, JSON.stringify(currentContext)); } catch (_) {}
  }));
  function start() {
    const page = document.querySelector('.page-collections');
    if (!page) return;
    new MutationObserver(records => {
      if (records.some(record => !panel.contains(record.target) && !returnPanel.contains(record.target) && (record.type === 'characterData' || [...record.addedNodes, ...record.removedNodes].some(item => item !== panel && item !== returnPanel)))) settle();
    }).observe(page, {childList:true, subtree:true, characterData:true});
    page.addEventListener('change', settle);
    page.addEventListener('submit', settle);
    sync();
  }
  window.addEventListener('globoFilterRenderCompleted', settle);
  window.addEventListener('pnm:bike-change', schedule);
  window.addEventListener('popstate', settle);
  window.addEventListener('pageshow', schedule);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pnm-wishlist-icon"] && !Shopify.designMode) return;
  try {
    (() => {
  const selector = '[data-pnm-wishlist-count]';
  function updateCounts() {
    let items;
    try {
      items = JSON.parse(localStorage.getItem('items') || '[]');
    } catch {
      return;
    }
    const count = Array.isArray(items)
      ? new Set(items.filter(item => typeof item === 'string' && item.trim())).size
      : 0;
    document.querySelectorAll(selector).forEach(badge => {
      const text = String(count);
      if (badge.textContent !== text) badge.textContent = text;
      badge.hidden = false;
      const link = badge.closest('[data-pnm-wishlist-link]');
      if (!link) return;
      const label = link.textContent.replace(badge.textContent, '').trim().replace(/\s+/g, ' ');
      link.setAttribute('aria-label', label + ' (' + count + ')');
    });
  }
  document.addEventListener('pnm:wishlist:change', updateCounts);
  document.addEventListener('shopify:section:load', updateCounts);
  window.addEventListener('pageshow', updateCounts);
  window.addEventListener('focus', updateCounts);
  window.addEventListener('storage', event => {
    if (event.key === 'items' || event.key === null) updateCounts();
  });
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) updateCounts();
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateCounts, { once: true });
  } else {
    updateCounts();
  }
})();

// Remember the source page before wishlist navigation, including filters and fragments.
(() => {
  const key = 'pnm_wishlist_last_page_v1';
  const isWishlist = path => /\/pages\/wish-list\/?$/.test(path);
  function remember() {
    if (isWishlist(location.pathname)) return;
    try { sessionStorage.setItem(key, JSON.stringify({url:location.href,time:Date.now()})); }
    catch (_) {}
  }
  function rememberLink(event) {
    if (event.type === 'auxclick' && event.button !== 1) return;
    const link = event.target.closest?.('a[href]');
    if (!link) return;
    try {
      const url = new URL(link.href, location.origin);
      if (url.origin === location.origin && isWishlist(url.pathname)) remember();
    } catch (_) {}
  }
  document.addEventListener('click', rememberLink, true);
  document.addEventListener('auxclick', rememberLink, true);
  window.addEventListener('pagehide', remember);
  window.addEventListener('pageshow', remember);
  remember();
})();
  } catch(e) { console.error(e); }
})();

})();
